var ji = Object.defineProperty;
var Vi = (e, t, n) => t in e ? ji(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var I = (e, t, n) => Vi(e, typeof t != "symbol" ? t + "" : t, n);
const Ve = "1.9.1", Jn = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Fi(e) {
  const t = /* @__PURE__ */ new Set([e]), n = /* @__PURE__ */ new Set(), r = e.match(Jn);
  if (!r)
    return () => !1;
  const i = {
    major: +r[1],
    minor: +r[2],
    patch: +r[3],
    prerelease: r[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(s) {
    return n.add(s), !1;
  }
  function a(s) {
    return t.add(s), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (n.has(c))
      return !1;
    const u = c.match(Jn);
    if (!u)
      return o(c);
    const l = {
      major: +u[1],
      minor: +u[2],
      patch: +u[3],
      prerelease: u[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
const Xi = Fi(Ve), Zi = Ve.split(".")[0], _t = Symbol.for(`opentelemetry.js.api.${Zi}`), dt = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function vt(e, t, n, r = !1) {
  var i;
  const o = dt[_t] = (i = dt[_t]) !== null && i !== void 0 ? i : {
    version: Ve
  };
  if (!r && o[e]) {
    const a = new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${e}`);
    return n.error(a.stack || a.message), !1;
  }
  if (o.version !== Ve) {
    const a = new Error(`@opentelemetry/api: Registration of version v${o.version} for ${e} does not match previously registered API v${Ve}`);
    return n.error(a.stack || a.message), !1;
  }
  return o[e] = t, n.debug(`@opentelemetry/api: Registered a global for ${e} v${Ve}.`), !0;
}
function Fe(e) {
  var t, n;
  const r = (t = dt[_t]) === null || t === void 0 ? void 0 : t.version;
  if (!(!r || !Xi(r)))
    return (n = dt[_t]) === null || n === void 0 ? void 0 : n[e];
}
function yt(e, t) {
  t.debug(`@opentelemetry/api: Unregistering a global for ${e} v${Ve}.`);
  const n = dt[_t];
  n && delete n[e];
}
class $i {
  constructor(t) {
    this._namespace = t.namespace || "DiagComponentLogger";
  }
  debug(...t) {
    return rt("debug", this._namespace, t);
  }
  error(...t) {
    return rt("error", this._namespace, t);
  }
  info(...t) {
    return rt("info", this._namespace, t);
  }
  warn(...t) {
    return rt("warn", this._namespace, t);
  }
  verbose(...t) {
    return rt("verbose", this._namespace, t);
  }
}
function rt(e, t, n) {
  const r = Fe("diag");
  if (r)
    return r[e](t, ...n);
}
var ne;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(ne || (ne = {}));
function zi(e, t) {
  e < ne.NONE ? e = ne.NONE : e > ne.ALL && (e = ne.ALL), t = t || {};
  function n(r, i) {
    const o = t[r];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: n("error", ne.ERROR),
    warn: n("warn", ne.WARN),
    info: n("info", ne.INFO),
    debug: n("debug", ne.DEBUG),
    verbose: n("verbose", ne.VERBOSE)
  };
}
const Wi = "diag";
class pe {
  /** Get the singleton instance of the DiagAPI API */
  static instance() {
    return this._instance || (this._instance = new pe()), this._instance;
  }
  /**
   * Private internal constructor
   * @private
   */
  constructor() {
    function t(i) {
      return function(...o) {
        const a = Fe("diag");
        if (a)
          return a[i](...o);
      };
    }
    const n = this, r = (i, o = { logLevel: ne.INFO }) => {
      var a, s, c;
      if (i === n) {
        const f = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
        return n.error((a = f.stack) !== null && a !== void 0 ? a : f.message), !1;
      }
      typeof o == "number" && (o = {
        logLevel: o
      });
      const u = Fe("diag"), l = zi((s = o.logLevel) !== null && s !== void 0 ? s : ne.INFO, i);
      if (u && !o.suppressOverrideMessage) {
        const f = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
        u.warn(`Current logger will be overwritten from ${f}`), l.warn(`Current logger will overwrite one already registered from ${f}`);
      }
      return vt("diag", l, n, !0);
    };
    n.setLogger = r, n.disable = () => {
      yt(Wi, n);
    }, n.createComponentLogger = (i) => new $i(i), n.verbose = t("verbose"), n.debug = t("debug"), n.info = t("info"), n.warn = t("warn"), n.error = t("error");
  }
}
class Ye {
  constructor(t) {
    this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
  }
  getEntry(t) {
    const n = this._entries.get(t);
    if (n)
      return Object.assign({}, n);
  }
  getAllEntries() {
    return Array.from(this._entries.entries());
  }
  setEntry(t, n) {
    const r = new Ye(this._entries);
    return r._entries.set(t, n), r;
  }
  removeEntry(t) {
    const n = new Ye(this._entries);
    return n._entries.delete(t), n;
  }
  removeEntries(...t) {
    const n = new Ye(this._entries);
    for (const r of t)
      n._entries.delete(r);
    return n;
  }
  clear() {
    return new Ye();
  }
}
const Ki = Symbol("BaggageEntryMetadata"), Yi = pe.instance();
function qi(e = {}) {
  return new Ye(new Map(Object.entries(e)));
}
function Qi(e) {
  return typeof e != "string" && (Yi.error(`Cannot create baggage metadata from unknown type: ${typeof e}`), e = ""), {
    __TYPE__: Ki,
    toString() {
      return e;
    }
  };
}
function bn(e) {
  return Symbol.for(e);
}
class Dt {
  /**
   * Construct a new context which inherits values from an optional parent context.
   *
   * @param parentContext a context from which to inherit values
   */
  constructor(t) {
    const n = this;
    n._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), n.getValue = (r) => n._currentContext.get(r), n.setValue = (r, i) => {
      const o = new Dt(n._currentContext);
      return o._currentContext.set(r, i), o;
    }, n.deleteValue = (r) => {
      const i = new Dt(n._currentContext);
      return i._currentContext.delete(r), i;
    };
  }
}
const Oe = new Dt();
class Ji {
  constructor() {
  }
  /**
   * @see {@link Meter.createGauge}
   */
  createGauge(t, n) {
    return co;
  }
  /**
   * @see {@link Meter.createHistogram}
   */
  createHistogram(t, n) {
    return lo;
  }
  /**
   * @see {@link Meter.createCounter}
   */
  createCounter(t, n) {
    return uo;
  }
  /**
   * @see {@link Meter.createUpDownCounter}
   */
  createUpDownCounter(t, n) {
    return fo;
  }
  /**
   * @see {@link Meter.createObservableGauge}
   */
  createObservableGauge(t, n) {
    return ho;
  }
  /**
   * @see {@link Meter.createObservableCounter}
   */
  createObservableCounter(t, n) {
    return _o;
  }
  /**
   * @see {@link Meter.createObservableUpDownCounter}
   */
  createObservableUpDownCounter(t, n) {
    return po;
  }
  /**
   * @see {@link Meter.addBatchObservableCallback}
   */
  addBatchObservableCallback(t, n) {
  }
  /**
   * @see {@link Meter.removeBatchObservableCallback}
   */
  removeBatchObservableCallback(t) {
  }
}
class Ft {
}
class eo extends Ft {
  add(t, n) {
  }
}
class to extends Ft {
  add(t, n) {
  }
}
class no extends Ft {
  record(t, n) {
  }
}
class ro extends Ft {
  record(t, n) {
  }
}
class Ln {
  addCallback(t) {
  }
  removeCallback(t) {
  }
}
class io extends Ln {
}
class oo extends Ln {
}
class ao extends Ln {
}
const so = new Ji(), uo = new eo(), co = new no(), lo = new ro(), fo = new to(), _o = new io(), ho = new oo(), po = new ao(), Eo = {
  get(e, t) {
    if (e != null)
      return e[t];
  },
  keys(e) {
    return e == null ? [] : Object.keys(e);
  }
}, To = {
  set(e, t, n) {
    e != null && (e[t] = n);
  }
};
class vo {
  active() {
    return Oe;
  }
  with(t, n, r, ...i) {
    return n.call(r, ...i);
  }
  bind(t, n) {
    return n;
  }
  enable() {
    return this;
  }
  disable() {
    return this;
  }
}
const qt = "context", yo = new vo();
class tt {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
  }
  /** Get the singleton instance of the Context API */
  static getInstance() {
    return this._instance || (this._instance = new tt()), this._instance;
  }
  /**
   * Set the current context manager.
   *
   * @returns true if the context manager was successfully registered, else false
   */
  setGlobalContextManager(t) {
    return vt(qt, t, pe.instance());
  }
  /**
   * Get the currently active context
   */
  active() {
    return this._getContextManager().active();
  }
  /**
   * Execute a function with an active context
   *
   * @param context context to be active during function execution
   * @param fn function to execute in a context
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */
  with(t, n, r, ...i) {
    return this._getContextManager().with(t, n, r, ...i);
  }
  /**
   * Bind a context to a target function or event emitter
   *
   * @param context context to bind to the event emitter or function. Defaults to the currently active context
   * @param target function or event emitter to bind
   */
  bind(t, n) {
    return this._getContextManager().bind(t, n);
  }
  _getContextManager() {
    return Fe(qt) || yo;
  }
  /** Disable and remove the global context manager */
  disable() {
    this._getContextManager().disable(), yt(qt, pe.instance());
  }
}
var Re;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(Re || (Re = {}));
const Ur = "0000000000000000", Hr = "00000000000000000000000000000000", Br = {
  traceId: Hr,
  spanId: Ur,
  traceFlags: Re.NONE
};
class ut {
  constructor(t = Br) {
    this._spanContext = t;
  }
  // Returns a SpanContext.
  spanContext() {
    return this._spanContext;
  }
  // By default does nothing
  setAttribute(t, n) {
    return this;
  }
  // By default does nothing
  setAttributes(t) {
    return this;
  }
  // By default does nothing
  addEvent(t, n) {
    return this;
  }
  addLink(t) {
    return this;
  }
  addLinks(t) {
    return this;
  }
  // By default does nothing
  setStatus(t) {
    return this;
  }
  // By default does nothing
  updateName(t) {
    return this;
  }
  // By default does nothing
  end(t) {
  }
  // isRecording always returns false for NonRecordingSpan.
  isRecording() {
    return !1;
  }
  // By default does nothing
  recordException(t, n) {
  }
}
const wn = bn("OpenTelemetry Context Key SPAN");
function Nn(e) {
  return e.getValue(wn) || void 0;
}
function go() {
  return Nn(tt.getInstance().active());
}
function Cn(e, t) {
  return e.setValue(wn, t);
}
function mo(e) {
  return e.deleteValue(wn);
}
function So(e, t) {
  return Cn(e, new ut(t));
}
function Gr(e) {
  var t;
  return (t = Nn(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
const Ot = new Uint8Array([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1
]);
function jr(e, t) {
  if (typeof e != "string" || e.length !== t)
    return !1;
  let n = 0;
  for (let r = 0; r < e.length; r += 4)
    n += (Ot[e.charCodeAt(r)] | 0) + (Ot[e.charCodeAt(r + 1)] | 0) + (Ot[e.charCodeAt(r + 2)] | 0) + (Ot[e.charCodeAt(r + 3)] | 0);
  return n === t;
}
function Vr(e) {
  return jr(e, 32) && e !== Hr;
}
function Oo(e) {
  return jr(e, 16) && e !== Ur;
}
function Xt(e) {
  return Vr(e.traceId) && Oo(e.spanId);
}
function Ro(e) {
  return new ut(e);
}
const Qt = tt.getInstance();
class Fr {
  // startSpan starts a noop span.
  startSpan(t, n, r = Qt.active()) {
    if (!!(n != null && n.root))
      return new ut();
    const o = r && Gr(r);
    return Ao(o) && Xt(o) ? new ut(o) : new ut();
  }
  startActiveSpan(t, n, r, i) {
    let o, a, s;
    if (arguments.length < 2)
      return;
    arguments.length === 2 ? s = n : arguments.length === 3 ? (o = n, s = r) : (o = n, a = r, s = i);
    const c = a ?? Qt.active(), u = this.startSpan(t, o, c), l = Cn(c, u);
    return Qt.with(l, s, void 0, u);
  }
}
function Ao(e) {
  return e !== null && typeof e == "object" && "spanId" in e && typeof e.spanId == "string" && "traceId" in e && typeof e.traceId == "string" && "traceFlags" in e && typeof e.traceFlags == "number";
}
const Po = new Fr();
class bo {
  constructor(t, n, r, i) {
    this._provider = t, this.name = n, this.version = r, this.options = i;
  }
  startSpan(t, n, r) {
    return this._getTracer().startSpan(t, n, r);
  }
  startActiveSpan(t, n, r, i) {
    const o = this._getTracer();
    return Reflect.apply(o.startActiveSpan, o, arguments);
  }
  /**
   * Try to get a tracer from the proxy tracer provider.
   * If the proxy tracer provider has no delegate, return a noop tracer.
   */
  _getTracer() {
    if (this._delegate)
      return this._delegate;
    const t = this._provider.getDelegateTracer(this.name, this.version, this.options);
    return t ? (this._delegate = t, this._delegate) : Po;
  }
}
class Lo {
  getTracer(t, n, r) {
    return new Fr();
  }
}
const wo = new Lo();
class er {
  /**
   * Get a {@link ProxyTracer}
   */
  getTracer(t, n, r) {
    var i;
    return (i = this.getDelegateTracer(t, n, r)) !== null && i !== void 0 ? i : new bo(this, t, n, r);
  }
  getDelegate() {
    var t;
    return (t = this._delegate) !== null && t !== void 0 ? t : wo;
  }
  /**
   * Set the delegate tracer provider
   */
  setDelegate(t) {
    this._delegate = t;
  }
  getDelegateTracer(t, n, r) {
    var i;
    return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, n, r);
  }
}
var kt;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(kt || (kt = {}));
var ht;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(ht || (ht = {}));
var En;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(En || (En = {}));
const F = tt.getInstance(), j = pe.instance();
class No {
  getMeter(t, n, r) {
    return so;
  }
}
const Co = new No(), Jt = "metrics";
class Mn {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
  }
  /** Get the singleton instance of the Metrics API */
  static getInstance() {
    return this._instance || (this._instance = new Mn()), this._instance;
  }
  /**
   * Set the current global meter provider.
   * Returns true if the meter provider was successfully registered, else false.
   */
  setGlobalMeterProvider(t) {
    return vt(Jt, t, pe.instance());
  }
  /**
   * Returns the global meter provider.
   */
  getMeterProvider() {
    return Fe(Jt) || Co;
  }
  /**
   * Returns a meter from the global meter provider.
   */
  getMeter(t, n, r) {
    return this.getMeterProvider().getMeter(t, n, r);
  }
  /** Remove the global meter provider */
  disable() {
    yt(Jt, pe.instance());
  }
}
const Xr = Mn.getInstance();
class Mo {
  /** Noop inject function does nothing */
  inject(t, n) {
  }
  /** Noop extract function does nothing and returns the input context */
  extract(t, n) {
    return t;
  }
  fields() {
    return [];
  }
}
const In = bn("OpenTelemetry Baggage Key");
function Zr(e) {
  return e.getValue(In) || void 0;
}
function Io() {
  return Zr(tt.getInstance().active());
}
function Do(e, t) {
  return e.setValue(In, t);
}
function ko(e) {
  return e.deleteValue(In);
}
const en = "propagation", xo = new Mo();
class Dn {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
    this.createBaggage = qi, this.getBaggage = Zr, this.getActiveBaggage = Io, this.setBaggage = Do, this.deleteBaggage = ko;
  }
  /** Get the singleton instance of the Propagator API */
  static getInstance() {
    return this._instance || (this._instance = new Dn()), this._instance;
  }
  /**
   * Set the current propagator.
   *
   * @returns true if the propagator was successfully registered, else false
   */
  setGlobalPropagator(t) {
    return vt(en, t, pe.instance());
  }
  /**
   * Inject context into a carrier to be propagated inter-process
   *
   * @param context Context carrying tracing data to inject
   * @param carrier carrier to inject context into
   * @param setter Function used to set values on the carrier
   */
  inject(t, n, r = To) {
    return this._getGlobalPropagator().inject(t, n, r);
  }
  /**
   * Extract context from a carrier
   *
   * @param context Context which the newly created context will inherit from
   * @param carrier Carrier to extract context from
   * @param getter Function used to extract keys from a carrier
   */
  extract(t, n, r = Eo) {
    return this._getGlobalPropagator().extract(t, n, r);
  }
  /**
   * Return a list of all fields which may be used by the propagator.
   */
  fields() {
    return this._getGlobalPropagator().fields();
  }
  /** Remove the global propagator */
  disable() {
    yt(en, pe.instance());
  }
  _getGlobalPropagator() {
    return Fe(en) || xo;
  }
}
const de = Dn.getInstance(), tn = "trace";
class kn {
  /** Empty private constructor prevents end users from constructing a new instance of the API */
  constructor() {
    this._proxyTracerProvider = new er(), this.wrapSpanContext = Ro, this.isSpanContextValid = Xt, this.deleteSpan = mo, this.getSpan = Nn, this.getActiveSpan = go, this.getSpanContext = Gr, this.setSpan = Cn, this.setSpanContext = So;
  }
  /** Get the singleton instance of the Trace API */
  static getInstance() {
    return this._instance || (this._instance = new kn()), this._instance;
  }
  /**
   * Set the current global tracer.
   *
   * @returns true if the tracer provider was successfully registered, else false
   */
  setGlobalTracerProvider(t) {
    const n = vt(tn, this._proxyTracerProvider, pe.instance());
    return n && this._proxyTracerProvider.setDelegate(t), n;
  }
  /**
   * Returns the global tracer provider.
   */
  getTracerProvider() {
    return Fe(tn) || this._proxyTracerProvider;
  }
  /**
   * Returns a tracer from the global tracer provider.
   */
  getTracer(t, n) {
    return this.getTracerProvider().getTracer(t, n);
  }
  /** Remove the global tracer provider */
  disable() {
    yt(tn, pe.instance()), this._proxyTracerProvider = new er();
  }
}
const Q = kn.getInstance();
var $r = bn("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function zr(e) {
  return e.setValue($r, !0);
}
function xn(e) {
  return e.getValue($r) === !0;
}
var Uo = "=", Tn = ";", vn = ",", nn = "baggage", Ho = 180, Bo = 4096, Go = 8192, jo = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Vo(e) {
  return e.reduce(function(t, n) {
    var r = "" + t + (t !== "" ? vn : "") + n;
    return r.length > Go ? t : r;
  }, "");
}
function Fo(e) {
  return e.getAllEntries().map(function(t) {
    var n = jo(t, 2), r = n[0], i = n[1], o = encodeURIComponent(r) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Tn + i.metadata.toString()), o;
  });
}
function Xo(e) {
  var t = e.split(Tn);
  if (!(t.length <= 0)) {
    var n = t.shift();
    if (n) {
      var r = n.indexOf(Uo);
      if (!(r <= 0)) {
        var i = decodeURIComponent(n.substring(0, r).trim()), o = decodeURIComponent(n.substring(r + 1).trim()), a;
        return t.length > 0 && (a = Qi(t.join(Tn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Zo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, n, r) {
      var i = de.getBaggage(t);
      if (!(!i || xn(t))) {
        var o = Fo(i).filter(function(s) {
          return s.length <= Bo;
        }).slice(0, Ho), a = Vo(o);
        a.length > 0 && r.set(n, nn, a);
      }
    }, e.prototype.extract = function(t, n, r) {
      var i = r.get(n, nn), o = Array.isArray(i) ? i.join(vn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var s = o.split(vn);
      return s.forEach(function(c) {
        var u = Xo(c);
        if (u) {
          var l = { value: u.value };
          u.metadata && (l.metadata = u.metadata), a[u.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : de.setBaggage(t, de.createBaggage(a));
    }, e.prototype.fields = function() {
      return [nn];
    }, e;
  }()
), Wr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $o = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function wt(e) {
  var t, n, r = {};
  if (typeof e != "object" || e == null)
    return r;
  try {
    for (var i = Wr(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = $o(o.value, 2), s = a[0], c = a[1];
      if (!zo(s)) {
        j.warn("Invalid attribute key: " + s);
        continue;
      }
      if (!Kr(c)) {
        j.warn("Invalid attribute value set for key: " + s);
        continue;
      }
      Array.isArray(c) ? r[s] = c.slice() : r[s] = c;
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
function zo(e) {
  return typeof e == "string" && e.length > 0;
}
function Kr(e) {
  return e == null ? !0 : Array.isArray(e) ? Wo(e) : Yr(e);
}
function Wo(e) {
  var t, n, r;
  try {
    for (var i = Wr(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!r) {
          if (Yr(a)) {
            r = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== r)
          return !1;
      }
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function Yr(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Ko() {
  return function(e) {
    j.error(Yo(e));
  };
}
function Yo(e) {
  return typeof e == "string" ? e : JSON.stringify(qo(e));
}
function qo(e) {
  for (var t = {}, n = e; n !== null; )
    Object.getOwnPropertyNames(n).forEach(function(r) {
      if (!t[r]) {
        var i = n[r];
        i && (t[r] = String(i));
      }
    }), n = Object.getPrototypeOf(n);
  return t;
}
var Qo = Ko();
function ke(e) {
  try {
    Qo(e);
  } catch {
  }
}
var Se;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(Se || (Se = {}));
var Jo = ",", ea = ["OTEL_SDK_DISABLED"];
function ta(e) {
  return ea.indexOf(e) > -1;
}
var na = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function ra(e) {
  return na.indexOf(e) > -1;
}
var ia = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function oa(e) {
  return ia.indexOf(e) > -1;
}
var Nt = 1 / 0, Ct = 128, aa = 128, sa = 128, qr = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: ne.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Nt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Ct,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Nt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Ct,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Nt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Ct,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: aa,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: sa,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Se.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function ua(e, t, n) {
  if (!(typeof n[e] > "u")) {
    var r = String(n[e]);
    t[e] = r.toLowerCase() === "true";
  }
}
function ca(e, t, n, r, i) {
  if (r === void 0 && (r = -1 / 0), i === void 0 && (i = 1 / 0), typeof n[e] < "u") {
    var o = Number(n[e]);
    isNaN(o) || (o < r ? t[e] = r : o > i ? t[e] = i : t[e] = o);
  }
}
function la(e, t, n, r) {
  r === void 0 && (r = Jo);
  var i = n[e];
  typeof i == "string" && (t[e] = i.split(r).map(function(o) {
    return o.trim();
  }));
}
var fa = {
  ALL: ne.ALL,
  VERBOSE: ne.VERBOSE,
  DEBUG: ne.DEBUG,
  INFO: ne.INFO,
  WARN: ne.WARN,
  ERROR: ne.ERROR,
  NONE: ne.NONE
};
function _a(e, t, n) {
  var r = n[e];
  if (typeof r == "string") {
    var i = fa[r.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function Qr(e) {
  var t = {};
  for (var n in qr) {
    var r = n;
    switch (r) {
      case "OTEL_LOG_LEVEL":
        _a(r, t, e);
        break;
      default:
        if (ta(r))
          ua(r, t, e);
        else if (ra(r))
          ca(r, t, e);
        else if (oa(r))
          la(r, t, e);
        else {
          var i = e[r];
          typeof i < "u" && i !== null && (t[r] = String(i));
        }
    }
  }
  return t;
}
var ct = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function pt() {
  var e = Qr(ct);
  return Object.assign({}, qr, e);
}
function da() {
  return Qr(ct);
}
function tr(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function Un(e) {
  for (var t = new Uint8Array(e.length / 2), n = 0, r = 0; r < e.length; r += 2) {
    var i = tr(e.charCodeAt(r)), o = tr(e.charCodeAt(r + 1));
    t[n++] = i << 4 | o;
  }
  return t;
}
var he = performance, ha = "1.30.1", pa = "process.runtime.name", Ea = "telemetry.sdk.name", Ta = "telemetry.sdk.language", va = "telemetry.sdk.version", ya = pa, ga = Ea, ma = Ta, Sa = va, Oa = "webjs", Ra = Oa, ze, rn = (ze = {}, ze[ga] = "opentelemetry", ze[ya] = "browser", ze[ma] = Ra, ze[Sa] = ha, ze);
var Aa = 9, Pa = 6, ba = Math.pow(10, Pa), xt = Math.pow(10, Aa);
function Ce(e) {
  var t = e / 1e3, n = Math.trunc(t), r = Math.round(e % 1e3 * ba);
  return [n, r];
}
function Hn() {
  var e = he.timeOrigin;
  if (typeof e != "number") {
    var t = he;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Xe(e) {
  var t = Ce(Hn()), n = Ce(typeof e == "number" ? e : he.now());
  return Jr(t, n);
}
function lt(e) {
  if (Bn(e))
    return e;
  if (typeof e == "number")
    return e < Hn() ? Xe(e) : Ce(e);
  if (e instanceof Date)
    return Ce(e.getTime());
  throw TypeError("Invalid input type");
}
function La(e, t) {
  var n = t[0] - e[0], r = t[1] - e[1];
  return r < 0 && (n -= 1, r += xt), [n, r];
}
function Me(e) {
  return e[0] * xt + e[1];
}
function nr(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function Bn(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function rr(e) {
  return Bn(e) || typeof e == "number" || e instanceof Date;
}
function Jr(e, t) {
  var n = [e[0] + t[0], e[1] + t[1]];
  return n[1] >= xt && (n[1] -= xt, n[0] += 1), n;
}
var le;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(le || (le = {}));
var wa = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Na = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var n;
      this._propagators = (n = t.propagators) !== null && n !== void 0 ? n : [], this._fields = Array.from(new Set(this._propagators.map(function(r) {
        return typeof r.fields == "function" ? r.fields() : [];
      }).reduce(function(r, i) {
        return r.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, n, r) {
      var i, o;
      try {
        for (var a = wa(this._propagators), s = a.next(); !s.done; s = a.next()) {
          var c = s.value;
          try {
            c.inject(t, n, r);
          } catch (u) {
            j.warn("Failed to inject with " + c.constructor.name + ". Err: " + u.message);
          }
        }
      } catch (u) {
        i = { error: u };
      } finally {
        try {
          s && !s.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, n, r) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, n, r);
        } catch (a) {
          j.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), yn = "[_0-9a-z-*/]", Ca = "[a-z]" + yn + "{0,255}", Ma = "[a-z0-9]" + yn + "{0,240}@[a-z]" + yn + "{0,13}", Ia = new RegExp("^(?:" + Ca + "|" + Ma + ")$"), Da = /^[ -~]{0,255}[!-~]$/, ka = /,|=/;
function xa(e) {
  return Ia.test(e);
}
function Ua(e) {
  return Da.test(e) && !ka.test(e);
}
var ir = 32, Ha = 512, or = ",", ar = "=", Ba = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, n) {
      var r = this._clone();
      return r._internalState.has(t) && r._internalState.delete(t), r._internalState.set(t, n), r;
    }, e.prototype.unset = function(t) {
      var n = this._clone();
      return n._internalState.delete(t), n;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(n, r) {
        return n.push(r + ar + t.get(r)), n;
      }, []).join(or);
    }, e.prototype._parse = function(t) {
      t.length > Ha || (this._internalState = t.split(or).reverse().reduce(function(n, r) {
        var i = r.trim(), o = i.indexOf(ar);
        if (o !== -1) {
          var a = i.slice(0, o), s = i.slice(o + 1, r.length);
          xa(a) && Ua(s) && n.set(a, s);
        }
        return n;
      }, /* @__PURE__ */ new Map()), this._internalState.size > ir && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, ir))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Mt = "traceparent", on = "tracestate", Ga = "00", ja = "(?!ff)[\\da-f]{2}", Va = "(?![0]{32})[\\da-f]{32}", Fa = "(?![0]{16})[\\da-f]{16}", Xa = "[\\da-f]{2}", Za = new RegExp("^\\s?(" + ja + ")-(" + Va + ")-(" + Fa + ")-(" + Xa + ")(-.*)?\\s?$");
function $a(e) {
  var t = Za.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var za = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, n, r) {
      var i = Q.getSpanContext(t);
      if (!(!i || xn(t) || !Xt(i))) {
        var o = Ga + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || Re.NONE).toString(16);
        r.set(n, Mt, o), i.traceState && r.set(n, on, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, n, r) {
      var i = r.get(n, Mt);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = $a(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var s = r.get(n, on);
      if (s) {
        var c = Array.isArray(s) ? s.join(",") : s;
        a.traceState = new Ba(typeof c == "string" ? c : void 0);
      }
      return Q.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Mt, on];
    }, e;
  }()
), Wa = "[object Object]", Ka = "[object Null]", Ya = "[object Undefined]", qa = Function.prototype, ei = qa.toString, Qa = ei.call(Object), Ja = es(Object.getPrototypeOf, Object), ti = Object.prototype, ni = ti.hasOwnProperty, Ge = Symbol ? Symbol.toStringTag : void 0, ri = ti.toString;
function es(e, t) {
  return function(n) {
    return e(t(n));
  };
}
function sr(e) {
  if (!ts(e) || ns(e) !== Wa)
    return !1;
  var t = Ja(e);
  if (t === null)
    return !0;
  var n = ni.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && ei.call(n) === Qa;
}
function ts(e) {
  return e != null && typeof e == "object";
}
function ns(e) {
  return e == null ? e === void 0 ? Ya : Ka : Ge && Ge in Object(e) ? rs(e) : is(e);
}
function rs(e) {
  var t = ni.call(e, Ge), n = e[Ge], r = !1;
  try {
    e[Ge] = void 0, r = !0;
  } catch {
  }
  var i = ri.call(e);
  return r && (t ? e[Ge] = n : delete e[Ge]), i;
}
function is(e) {
  return ri.call(e);
}
var os = 20;
function as() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = e.shift(), r = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    n = ii(n, e.shift(), 0, r);
  return n;
}
function an(e) {
  return Ut(e) ? e.slice() : e;
}
function ii(e, t, n, r) {
  n === void 0 && (n = 0);
  var i;
  if (!(n > os)) {
    if (n++, It(e) || It(t) || oi(t))
      i = an(t);
    else if (Ut(e)) {
      if (i = e.slice(), Ut(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(an(t[o]));
      else if (it(t))
        for (var s = Object.keys(t), o = 0, a = s.length; o < a; o++) {
          var c = s[o];
          i[c] = an(t[c]);
        }
    } else if (it(e))
      if (it(t)) {
        if (!ss(e, t))
          return t;
        i = Object.assign({}, e);
        for (var s = Object.keys(t), o = 0, a = s.length; o < a; o++) {
          var c = s[o], u = t[c];
          if (It(u))
            typeof u > "u" ? delete i[c] : i[c] = u;
          else {
            var l = i[c], f = u;
            if (ur(e, c, r) || ur(t, c, r))
              delete i[c];
            else {
              if (it(l) && it(f)) {
                var E = r.get(l) || [], S = r.get(f) || [];
                E.push({ obj: e, key: c }), S.push({ obj: t, key: c }), r.set(l, E), r.set(f, S);
              }
              i[c] = ii(i[c], u, n, r);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function ur(e, t, n) {
  for (var r = n.get(e[t]) || [], i = 0, o = r.length; i < o; i++) {
    var a = r[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function Ut(e) {
  return Array.isArray(e);
}
function oi(e) {
  return typeof e == "function";
}
function it(e) {
  return !It(e) && !Ut(e) && !oi(e) && typeof e == "object";
}
function It(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e > "u" || e instanceof Date || e instanceof RegExp || e === null;
}
function ss(e, t) {
  return !(!sr(e) || !sr(t));
}
var us = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ai(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function si(e, t) {
  var n, r;
  if (!t)
    return !1;
  try {
    for (var i = us(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (ai(e, a))
        return !0;
    }
  } catch (s) {
    n = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (n) throw n.error;
    }
  }
  return !1;
}
var cs = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(n, r) {
        t._resolve = n, t._reject = r;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), ls = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, fs = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ui = (
  /** @class */
  function() {
    function e(t, n) {
      this._callback = t, this._that = n, this._isCalled = !1, this._deferred = new cs();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, fs([this._that], ls(r), !1))).then(function(o) {
            return n._deferred.resolve(o);
          }, function(o) {
            return n._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
);
function _s(e, t) {
  return new Promise(function(n) {
    F.with(zr(F.active()), function() {
      e.export(t, function(r) {
        n(r);
      });
    });
  });
}
var ds = {
  _export: _s
}, hs = "exception.type", ps = "exception.message", Es = "exception.stacktrace", sn = hs, un = ps, Ts = Es, vs = "exception", gn = function() {
  return gn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, gn.apply(this, arguments);
}, ys = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, cr = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, gs = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ms = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, s, c, u, l) {
      s === void 0 && (s = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: En.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = r, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = s;
      var f = Date.now();
      this._performanceStartTime = he.now(), this._performanceOffset = f - (this._performanceStartTime + Hn()), this._startTimeProvided = c != null, this.startTime = this._getTime(c ?? f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, n);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, n) {
      return n == null || this._isSpanEnded() ? this : t.length === 0 ? (j.warn("Invalid attribute key: " + t), this) : Kr(n) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(n), this) : (j.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var n, r;
      try {
        for (var i = ys(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = cr(o.value, 2), s = a[0], c = a[1];
          this.setAttribute(s, c);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, n, r) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return j.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && j.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), rr(n) && (rr(r) || (r = n), n = void 0);
      var i = wt(n);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(r),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var n;
      return (n = this.links).push.apply(n, gs([], cr(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = gn({}, t), this.status.message != null && typeof t.message != "string" && (j.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        j.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = La(this.startTime, this.endTime), this._duration[0] < 0 && (j.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && j.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= he.now())
        return Xe(t + this._performanceOffset);
      if (typeof t == "number")
        return Ce(t);
      if (t instanceof Date)
        return Ce(t.getTime());
      if (Bn(t))
        return t;
      if (this._startTimeProvided)
        return Ce(Date.now());
      var n = he.now() - this._performanceStartTime;
      return Jr(this.startTime, Ce(n));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, n) {
      var r = {};
      typeof t == "string" ? r[un] = t : t && (t.code ? r[sn] = t.code.toString() : t.name && (r[sn] = t.name), t.message && (r[un] = t.message), t.stack && (r[Ts] = t.stack)), r[sn] || r[un] ? this.addEvent(vs, r, n) : j.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && j.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, n) {
      return t.length <= n ? t : t.substring(0, n);
    }, e.prototype._truncateToSize = function(t) {
      var n = this, r = this._attributeValueLengthLimit;
      return r <= 0 ? (j.warn("Attribute value limit must be positive, got " + r), t) : typeof t == "string" ? this._truncateToLimitUtil(t, r) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? n._truncateToLimitUtil(i, r) : i;
      }) : t;
    }, e;
  }()
), Je;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Je || (Je = {}));
var Ht = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Je.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), Qe = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Je.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), cn = (
  /** @class */
  function() {
    function e(t) {
      var n, r, i, o;
      this._root = t.root, this._root || (ke(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new Qe()), this._remoteParentSampled = (n = t.remoteParentSampled) !== null && n !== void 0 ? n : new Qe(), this._remoteParentNotSampled = (r = t.remoteParentNotSampled) !== null && r !== void 0 ? r : new Ht(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new Qe(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new Ht();
    }
    return e.prototype.shouldSample = function(t, n, r, i, o, a) {
      var s = Q.getSpanContext(t);
      return !s || !Xt(s) ? this._root.shouldSample(t, n, r, i, o, a) : s.isRemote ? s.traceFlags & Re.SAMPLED ? this._remoteParentSampled.shouldSample(t, n, r, i, o, a) : this._remoteParentNotSampled.shouldSample(t, n, r, i, o, a) : s.traceFlags & Re.SAMPLED ? this._localParentSampled.shouldSample(t, n, r, i, o, a) : this._localParentNotSampled.shouldSample(t, n, r, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), lr = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, n) {
      return {
        decision: Vr(n) && this._accumulate(n) < this._upperBound ? Je.RECORD_AND_SAMPLED : Je.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var n = 0, r = 0; r < t.length / 8; r++) {
        var i = r * 8, o = parseInt(t.slice(i, i + 8), 16);
        n = (n ^ o) >>> 0;
      }
      return n;
    }, e;
  }()
), Ss = Se.AlwaysOn, We = 1;
function ci() {
  var e = pt();
  return {
    sampler: li(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function li(e) {
  switch (e === void 0 && (e = pt()), e.OTEL_TRACES_SAMPLER) {
    case Se.AlwaysOn:
      return new Qe();
    case Se.AlwaysOff:
      return new Ht();
    case Se.ParentBasedAlwaysOn:
      return new cn({
        root: new Qe()
      });
    case Se.ParentBasedAlwaysOff:
      return new cn({
        root: new Ht()
      });
    case Se.TraceIdRatio:
      return new lr(fr(e));
    case Se.ParentBasedTraceIdRatio:
      return new cn({
        root: new lr(fr(e))
      });
    default:
      return j.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + Ss + '".'), new Qe();
  }
}
function fr(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return j.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + We + "."), We;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (j.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + We + "."), We) : t < 0 || t > 1 ? (j.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + We + "."), We) : t;
}
function Os(e) {
  var t = {
    sampler: li()
  }, n = ci(), r = Object.assign({}, n, t, e);
  return r.generalLimits = Object.assign({}, n.generalLimits, e.generalLimits || {}), r.spanLimits = Object.assign({}, n.spanLimits, e.spanLimits || {}), r;
}
function Rs(e) {
  var t, n, r, i, o, a, s, c, u, l, f, E, S = Object.assign({}, e.spanLimits), O = da();
  return S.attributeCountLimit = (a = (o = (i = (n = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && n !== void 0 ? n : (r = e.generalLimits) === null || r === void 0 ? void 0 : r.attributeCountLimit) !== null && i !== void 0 ? i : O.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : O.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Ct, S.attributeValueLengthLimit = (E = (f = (l = (c = (s = e.spanLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && c !== void 0 ? c : (u = e.generalLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && l !== void 0 ? l : O.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : O.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && E !== void 0 ? E : Nt, Object.assign({}, e, { spanLimits: S });
}
var As = (
  /** @class */
  function() {
    function e(t, n) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var r = pt();
      this._maxExportBatchSize = typeof (n == null ? void 0 : n.maxExportBatchSize) == "number" ? n.maxExportBatchSize : r.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (n == null ? void 0 : n.maxQueueSize) == "number" ? n.maxQueueSize : r.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (n == null ? void 0 : n.scheduledDelayMillis) == "number" ? n.scheduledDelayMillis : r.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (n == null ? void 0 : n.exportTimeoutMillis) == "number" ? n.exportTimeoutMillis : r.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new ui(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (j.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, n) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & Re.SAMPLED && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && j.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (j.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(n, r) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, s = o; a < s; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          n();
        }).catch(r);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(n, r) {
        var i = setTimeout(function() {
          r(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        F.with(zr(F.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var E;
              clearTimeout(i), f.code === le.SUCCESS ? n() : r((E = f.error) !== null && E !== void 0 ? E : new Error("BatchSpanProcessor: span export failed"));
            });
          }, s = null, c = 0, u = o.length; c < u; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (s ?? (s = []), s.push(l.resource.waitForAsyncAttributes()));
          }
          s === null ? a() : Promise.all(s).then(a, function(f) {
            ke(f), r(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var n = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(r) {
            t._isExporting = !1, ke(r);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return n();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return n();
        }, this._scheduledDelayMillis), this._timer, void 0);
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Ps = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), fi = (
  /** @class */
  function(e) {
    Ps(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      return i.onInit(r), i;
    }
    return t.prototype.onInit = function(n) {
      var r = this;
      (n == null ? void 0 : n.disableAutoFlushOnDocumentHide) !== !0 && typeof document < "u" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && r.forceFlush().catch(function(i) {
          ke(i);
        });
      }, this._pageHideListener = function() {
        r.forceFlush().catch(function(i) {
          ke(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document < "u" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(As)
), bs = 8, Ls = 16, ws = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = _r(Ls), this.generateSpanId = _r(bs);
    }
    return e;
  }()
), Rt = Array(32);
function _r(e) {
  return function() {
    for (var n = 0; n < e * 2; n++)
      Rt[n] = Math.floor(Math.random() * 16) + 48, Rt[n] >= 58 && (Rt[n] += 39);
    return String.fromCharCode.apply(null, Rt.slice(0, e * 2));
  };
}
var Ns = (
  /** @class */
  function() {
    function e(t, n, r) {
      this._tracerProvider = r;
      var i = Os(n);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = n.idGenerator || new ws(), this.resource = r.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, n, r) {
      var i, o, a;
      n === void 0 && (n = {}), r === void 0 && (r = F.active()), n.root && (r = Q.deleteSpan(r));
      var s = Q.getSpan(r);
      if (xn(r)) {
        j.debug("Instrumentation suppressed, returning Noop Span");
        var c = Q.wrapSpanContext(Br);
        return c;
      }
      var u = s == null ? void 0 : s.spanContext(), l = this._idGenerator.generateSpanId(), f, E, S;
      !u || !Q.isSpanContextValid(u) ? f = this._idGenerator.generateTraceId() : (f = u.traceId, E = u.traceState, S = u.spanId);
      var O = (i = n.kind) !== null && i !== void 0 ? i : ht.INTERNAL, R = ((o = n.links) !== null && o !== void 0 ? o : []).map(function(q) {
        return {
          context: q.context,
          attributes: wt(q.attributes)
        };
      }), k = wt(n.attributes), b = this._sampler.shouldSample(r, f, t, O, k, R);
      E = (a = b.traceState) !== null && a !== void 0 ? a : E;
      var m = b.decision === kt.RECORD_AND_SAMPLED ? Re.SAMPLED : Re.NONE, y = { traceId: f, spanId: l, traceFlags: m, traceState: E };
      if (b.decision === kt.NOT_RECORD) {
        j.debug("Recording is off, propagating context in a non-recording span");
        var c = Q.wrapSpanContext(y);
        return c;
      }
      var X = wt(Object.assign(k, b.attributes)), Z = new ms(this, r, t, y, O, S, R, n.startTime, void 0, X);
      return Z;
    }, e.prototype.startActiveSpan = function(t, n, r, i) {
      var o, a, s;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? s = n : arguments.length === 3 ? (o = n, s = r) : (o = n, a = r, s = i);
        var c = a ?? F.active(), u = this.startSpan(t, o, c), l = Q.setSpan(c, u);
        return F.with(l, s, void 0, u);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
), Cs = "service.name", Ms = "telemetry.sdk.name", Is = "telemetry.sdk.language", Ds = "telemetry.sdk.version", ks = Cs, dr = Ms, hr = Is, pr = Ds;
function xs() {
  return "unknown_service";
}
var He = function() {
  return He = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, He.apply(this, arguments);
}, Us = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, Hs = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Bs = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, mn = (
  /** @class */
  function() {
    function e(t, n) {
      var r = this, i;
      this._attributes = t, this.asyncAttributesPending = n != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = n == null ? void 0 : n.then(function(o) {
        return r._attributes = Object.assign({}, r._attributes, o), r.asyncAttributesPending = !1, o;
      }, function(o) {
        return j.debug("a resource's async attributes promise rejected: %s", o), r.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[ks] = xs(), t[hr] = rn[hr], t[dr] = rn[dr], t[pr] = rn[pr], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && j.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Us(this, void 0, void 0, function() {
        return Hs(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var n = this, r;
      if (!t)
        return this;
      var i = He(He({}, this._syncAttributes), (r = t._syncAttributes) !== null && r !== void 0 ? r : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var s, c = Bs(a, 2), u = c[0], l = c[1];
        return He(He(He(He({}, n._syncAttributes), u), (s = t._syncAttributes) !== null && s !== void 0 ? s : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), At = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Er = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, n, r = [];
      try {
        for (var i = At(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          r.push(a.forceFlush());
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(s) {
        Promise.all(r).then(function() {
          s();
        }).catch(function(c) {
          ke(c || new Error("MultiSpanProcessor: forceFlush failed")), s();
        });
      });
    }, e.prototype.onStart = function(t, n) {
      var r, i;
      try {
        for (var o = At(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          s.onStart(t, n);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var n, r;
      try {
        for (var i = At(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (s) {
        n = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, n, r = [];
      try {
        for (var i = At(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          r.push(a.shutdown());
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(s, c) {
        Promise.all(r).then(function() {
          s();
        }, c);
      });
    }, e;
  }()
), Gs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, n) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), js = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Vs = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, je;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(je || (je = {}));
var Fs = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var n, r;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = as({}, ci(), Rs(t));
      if (this.resource = (n = i.resource) !== null && n !== void 0 ? n : mn.empty(), i.mergeResourceWithDefaults && (this.resource = mn.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((r = t.spanProcessors) === null || r === void 0) && r.length)
        this._registeredSpanProcessors = Vs([], js(t.spanProcessors), !1), this.activeSpanProcessor = new Er(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new fi(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new Gs();
      }
    }
    return e.prototype.getTracer = function(t, n, r) {
      var i = t + "@" + (n || "") + ":" + ((r == null ? void 0 : r.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Ns({ name: t, version: n, schemaUrl: r == null ? void 0 : r.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(n) {
        return j.error("Error while trying to shutdown current span processor", n);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Er(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), Q.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && F.setGlobalContextManager(t.contextManager), t.propagator && de.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, n = this._registeredSpanProcessors.map(function(r) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = je.timeout;
          }, t);
          r.forceFlush().then(function() {
            clearTimeout(a), o !== je.timeout && (o = je.resolved, i(o));
          }).catch(function(s) {
            clearTimeout(a), o = je.error, i(s);
          });
        });
      });
      return new Promise(function(r, i) {
        Promise.all(n).then(function(o) {
          var a = o.filter(function(s) {
            return s !== je.resolved;
          });
          a.length > 0 ? i(a) : r();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var n;
      return (n = this.constructor._registeredPropagators.get(t)) === null || n === void 0 ? void 0 : n();
    }, e.prototype._getSpanExporter = function(t) {
      var n;
      return (n = this.constructor._registeredExporters.get(t)) === null || n === void 0 ? void 0 : n();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, n = Array.from(new Set(pt().OTEL_PROPAGATORS)), r = n.map(function(o) {
        var a = t._getPropagator(o);
        return a || j.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = r.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return n.length === 1 ? i[0] : new Na({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = pt().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var n = this._getSpanExporter(t);
        return n || j.error('Exporter "' + t + '" requested through environment variable is unavailable.'), n;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new za();
      }],
      ["baggage", function() {
        return new Zo();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), Xs = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Zs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.export = function(t, n) {
      return this._sendSpans(t, n);
    }, e.prototype.shutdown = function() {
      return this._sendSpans([]), this.forceFlush();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e.prototype._exportInfo = function(t) {
      var n;
      return {
        resource: {
          attributes: t.resource.attributes
        },
        instrumentationScope: t.instrumentationLibrary,
        traceId: t.spanContext().traceId,
        parentId: t.parentSpanId,
        traceState: (n = t.spanContext().traceState) === null || n === void 0 ? void 0 : n.serialize(),
        name: t.name,
        id: t.spanContext().spanId,
        kind: t.kind,
        timestamp: nr(t.startTime),
        duration: nr(t.duration),
        attributes: t.attributes,
        status: t.status,
        events: t.events,
        links: t.links
      };
    }, e.prototype._sendSpans = function(t, n) {
      var r, i;
      try {
        for (var o = Xs(t), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          console.dir(this._exportInfo(s), { depth: 3 });
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      if (n)
        return n({ code: le.SUCCESS });
    }, e;
  }()
), $s = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, zs = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Ws = (
  /** @class */
  function() {
    function e(t) {
      this._exporter = t, this._shutdownOnce = new ui(this._shutdown, this), this._unresolvedExports = /* @__PURE__ */ new Set();
    }
    return e.prototype.forceFlush = function() {
      return $s(this, void 0, void 0, function() {
        return zs(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(Array.from(this._unresolvedExports))];
            case 1:
              return t.sent(), this._exporter.forceFlush ? [4, this._exporter.forceFlush()] : [3, 3];
            case 2:
              t.sent(), t.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onStart = function(t, n) {
    }, e.prototype.onEnd = function(t) {
      var n = this, r, i;
      if (!this._shutdownOnce.isCalled && t.spanContext().traceFlags & Re.SAMPLED) {
        var o = function() {
          return ds._export(n._exporter, [t]).then(function(s) {
            var c;
            s.code !== le.SUCCESS && ke((c = s.error) !== null && c !== void 0 ? c : new Error("SimpleSpanProcessor: span export failed (status " + s + ")"));
          }).catch(function(s) {
            ke(s);
          });
        };
        if (t.resource.asyncAttributesPending) {
          var a = (i = (r = t.resource).waitForAsyncAttributes) === null || i === void 0 ? void 0 : i.call(r).then(function() {
            return a != null && n._unresolvedExports.delete(a), o();
          }, function(s) {
            return ke(s);
          });
          a != null && this._unresolvedExports.add(a);
        } else
          o();
      }
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      return this._exporter.shutdown();
    }, e;
  }()
), Ks = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ys = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, qs = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = Oe;
    }
    return e.prototype._bindFunction = function(t, n) {
      t === void 0 && (t = Oe);
      var r = this, i = function() {
        for (var o = this, a = [], s = 0; s < arguments.length; s++)
          a[s] = arguments[s];
        return r.with(t, function() {
          return n.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: n.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, n) {
      return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : n;
    }, e.prototype.disable = function() {
      return this._currentContext = Oe, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = Oe, this);
    }, e.prototype.with = function(t, n, r) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || Oe;
      try {
        return n.call.apply(n, Ys([r], Ks(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), Qs = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Js = (
  /** @class */
  function(e) {
    Qs(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, n) || this;
      if (n.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (n.propagator)
        throw "propagator should be defined in register method not in constructor";
      return r;
    }
    return t.prototype.register = function(n) {
      n === void 0 && (n = {}), n.contextManager === void 0 && (n.contextManager = new qs()), n.contextManager && n.contextManager.enable(), e.prototype.register.call(this, n);
    }, t;
  }(Fs)
), D;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(D || (D = {}));
var eu = "http.response_content_length", tu = "http.response_content_length_uncompressed", nu = eu, ru = tu, ln;
function iu() {
  return ln || (ln = document.createElement("a")), ln;
}
function Be(e, t) {
  return t in e;
}
function ae(e, t, n, r) {
  var i = void 0, o = void 0;
  Be(n, t) && typeof n[t] == "number" && (i = n[t]);
  var a = D.FETCH_START;
  if (Be(n, a) && typeof n[a] == "number" && (o = n[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function et(e, t, n) {
  n === void 0 && (n = !1), n || (ae(e, D.FETCH_START, t), ae(e, D.DOMAIN_LOOKUP_START, t), ae(e, D.DOMAIN_LOOKUP_END, t), ae(e, D.CONNECT_START, t), Be(t, "name") && t.name.startsWith("https:") && ae(e, D.SECURE_CONNECTION_START, t), ae(e, D.CONNECT_END, t), ae(e, D.REQUEST_START, t), ae(e, D.RESPONSE_START, t), ae(e, D.RESPONSE_END, t));
  var r = t[D.ENCODED_BODY_SIZE];
  r !== void 0 && e.setAttribute(nu, r);
  var i = t[D.DECODED_BODY_SIZE];
  i !== void 0 && r !== i && e.setAttribute(ru, i);
}
function ou(e) {
  return e.slice().sort(function(t, n) {
    var r = t[D.FETCH_START], i = n[D.FETCH_START];
    return r > i ? 1 : r < i ? -1 : 0;
  });
}
function _i() {
  return typeof location < "u" ? location.origin : void 0;
}
function di(e, t, n, r, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = Le(e);
  e = a.toString();
  var s = su(e, t, n, r, i, o);
  if (s.length === 0)
    return {
      mainRequest: void 0
    };
  if (s.length === 1)
    return {
      mainRequest: s[0]
    };
  var c = ou(s);
  if (a.origin !== _i() && c.length > 1) {
    var u = c[0], l = au(c, u[D.RESPONSE_END], n), f = u[D.RESPONSE_END], E = l[D.FETCH_START];
    return E < f && (l = u, u = void 0), {
      corsPreFlightRequest: u,
      mainRequest: l
    };
  } else
    return {
      mainRequest: s[0]
    };
}
function au(e, t, n) {
  for (var r = Me(n), i = Me(lt(t)), o = e[1], a, s = e.length, c = 1; c < s; c++) {
    var u = e[c], l = Me(lt(u[D.FETCH_START])), f = Me(lt(u[D.RESPONSE_END])), E = r - f;
    l >= i && (!a || E < a) && (a = E, o = u);
  }
  return o;
}
function su(e, t, n, r, i, o) {
  var a = Me(t), s = Me(n), c = r.filter(function(u) {
    var l = Me(lt(u[D.FETCH_START])), f = Me(lt(u[D.RESPONSE_END]));
    return u.initiatorType.toLowerCase() === (o || "xmlhttprequest") && u.name === e && l >= a && f <= s;
  });
  return c.length > 0 && (c = c.filter(function(u) {
    return !i.has(u);
  })), c;
}
function Le(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document < "u" ? document.baseURI : typeof location < "u" ? location.href : void 0);
  var t = iu();
  return t.href = e, t;
}
function hi(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var n = cu(e, t);
  if (t && n.indexOf("@id") > 0)
    return n;
  var r = "";
  return e.parentNode && (r += hi(e.parentNode, !1)), r += n, r;
}
function uu(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var n = Array.from(e.parentNode.childNodes);
  return n = n.filter(function(r) {
    var i = r.localName;
    return t.indexOf(r.nodeType) >= 0 && i === e.localName;
  }), n.length >= 1 ? n.indexOf(e) + 1 : 0;
}
function cu(e, t) {
  var n = e.nodeType, r = uu(e), i = "";
  if (n === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (n === Node.TEXT_NODE || n === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (n === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && r > 1 ? "/" + i + "[" + r + "]" : "/" + i;
}
function pi(e, t) {
  var n = t || [];
  (typeof n == "string" || n instanceof RegExp) && (n = [n]);
  var r = Le(e);
  return r.origin === _i() ? !0 : n.some(function(i) {
    return ai(e, i);
  });
}
var lu = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, n) {
      this._delegate.export(t, n);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), fu = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Tr = (
  /** @class */
  function(e) {
    fu(t, e);
    function t(n, r, i) {
      var o = e.call(this, n) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = r, o;
    }
    return t;
  }(Error)
);
function _u(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function du(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function hu(e, t, n) {
  var r, i, o, a, s, c;
  return {
    timeoutMillis: _u((i = (r = e.timeoutMillis) !== null && r !== void 0 ? r : t.timeoutMillis) !== null && i !== void 0 ? i : n.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : n.concurrencyLimit,
    compression: (c = (s = e.compression) !== null && s !== void 0 ? s : t.compression) !== null && c !== void 0 ? c : n.compression
  };
}
function pu() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var Eu = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, Tu = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, vu = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var n = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var r = function() {
        var i = n._sendingPromises.indexOf(t);
        n._sendingPromises.splice(i, 1);
      };
      t.then(r, r);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return Eu(this, void 0, void 0, function() {
        return Tu(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function yu(e) {
  return new vu(e.concurrencyLimit);
}
function gu(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function mu() {
  return {
    handleResponse: function(e) {
      e == null || !gu(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || j.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var Su = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, Ou = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Ru = (
  /** @class */
  function() {
    function e(t, n, r, i, o) {
      this._transport = t, this._serializer = n, this._responseHandler = r, this._promiseQueue = i, this._timeout = o, this._diagLogger = j.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, n) {
      var r = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        n({
          code: le.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        n({
          code: le.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              r._responseHandler.handleResponse(r._serializer.deserializeResponse(o.data));
            } catch (a) {
              r._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          n({
            code: le.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          n({
            code: le.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? n({
          code: le.FAILED,
          error: new Tr("Export failed with retryable status")
        }) : n({
          code: le.FAILED,
          error: new Tr("Export failed with unknown error")
        });
      }, function(o) {
        return n({
          code: le.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return Su(this, void 0, void 0, function() {
        return Ou(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Au(e, t) {
  return new Ru(e.transport, e.serializer, mu(), e.promiseHandler, t.timeout);
}
function Ei(e, t, n) {
  return Au({
    transport: n,
    serializer: t,
    promiseHandler: yu(e)
  }, { timeout: e.timeoutMillis });
}
function Ti(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function Pu(e) {
  var t = Number(BigInt.asUintN(32, e)), n = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: n };
}
function vi(e) {
  var t = Ti(e);
  return Pu(t);
}
function bu(e) {
  var t = Ti(e);
  return t.toString();
}
var Lu = typeof BigInt < "u" ? bu : Me;
function vr(e) {
  return e;
}
function yi(e) {
  if (e !== void 0)
    return Un(e);
}
var wu = {
  encodeHrTime: vi,
  encodeSpanContext: Un,
  encodeOptionalSpanContext: yi
};
function Nu(e) {
  var t, n;
  if (e === void 0)
    return wu;
  var r = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (n = e.useHex) !== null && n !== void 0 ? n : !1;
  return {
    encodeHrTime: r ? vi : Lu,
    encodeSpanContext: i ? vr : Un,
    encodeOptionalSpanContext: i ? vr : yi
  };
}
var Cu = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Mu(e) {
  return {
    attributes: Zt(e.attributes),
    droppedAttributesCount: 0
  };
}
function Iu(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Zt(e) {
  return Object.keys(e).map(function(t) {
    return gi(t, e[t]);
  });
}
function gi(e, t) {
  return {
    key: e,
    value: mi(t)
  };
}
function mi(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(mi) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(n) {
        var r = Cu(n, 2), i = r[0], o = r[1];
        return gi(i, o);
      })
    }
  } : {};
}
var Du = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ku = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function xu(e, t) {
  var n, r = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(r.traceId),
    spanId: t.encodeSpanContext(r.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (n = r.traceState) === null || n === void 0 ? void 0 : n.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Zt(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return Hu(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return Uu(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function Uu(e, t) {
  var n;
  return {
    attributes: e.attributes ? Zt(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (n = e.context.traceState) === null || n === void 0 ? void 0 : n.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Hu(e, t) {
  return {
    attributes: e.attributes ? Zt(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Bu(e, t) {
  var n = Nu(t);
  return {
    resourceSpans: ju(e, n)
  };
}
function Gu(e) {
  var t, n, r = /* @__PURE__ */ new Map();
  try {
    for (var i = Du(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, s = r.get(a.resource);
      s || (s = /* @__PURE__ */ new Map(), r.set(a.resource, s));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), u = s.get(c);
      u || (u = [], s.set(c, u)), u.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
function ju(e, t) {
  for (var n = Gu(e), r = [], i = n.entries(), o = i.next(); !o.done; ) {
    for (var a = ku(o.value, 2), s = a[0], c = a[1], u = [], l = c.values(), f = l.next(); !f.done; ) {
      var E = f.value;
      if (E.length > 0) {
        var S = E.map(function(R) {
          return xu(R, t);
        });
        u.push({
          scope: Iu(E[0].instrumentationLibrary),
          spans: S,
          schemaUrl: E[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var O = {
      resource: Mu(s),
      scopeSpans: u,
      schemaUrl: void 0
    };
    r.push(O), o = i.next();
  }
  return r;
}
var Vu = {
  serializeRequest: function(e) {
    var t = Bu(e, {
      useHex: !0,
      useLongBits: !1
    }), n = new TextEncoder();
    return n.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Fu = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, Xu = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Zu = 5, $u = 1e3, zu = 5e3, Wu = 1.5, yr = 0.2;
function Ku() {
  return Math.random() * (2 * yr) - yr;
}
var Yu = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, n, r) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, n).then(o, a);
        }, r);
      });
    }, e.prototype.send = function(t, n) {
      var r;
      return Fu(this, void 0, void 0, function() {
        var i, o, a, s, c, u, l;
        return Xu(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + n, [4, this._transport.send(t, n)];
            case 1:
              o = f.sent(), a = Zu, s = $u, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(s, zu) + Ku(), 0), s = s * Wu, u = (r = o.retryInMillis) !== null && r !== void 0 ? r : c, l = i - Date.now(), u > l ? [2, o] : [4, this.retry(t, l, u)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function Si(e) {
  return new Yu(e.transport);
}
function qu(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function Qu(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var n = new Date(e).getTime() - Date.now();
    return n >= 0 ? n : 0;
  }
}
var Ju = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ec = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, n) {
      var r = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = n, o.open("POST", r._parameters.url);
        var a = r._parameters.headers();
        Object.entries(a).forEach(function(s) {
          var c = Ju(s, 2), u = c[0], l = c[1];
          o.setRequestHeader(u, l);
        }), o.ontimeout = function(s) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (j.debug("XHR success"), i({
            status: "success"
          })) : o.status && qu(o.status) ? i({
            status: "retryable",
            retryInMillis: Qu(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function tc(e) {
  return new ec(e);
}
var nc = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var n = this;
      return new Promise(function(r) {
        navigator.sendBeacon(n._params.url, new Blob([t], { type: n._params.blobType })) ? (j.debug("SendBeacon success"), r({
          status: "success"
        })) : r({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function rc(e) {
  return new nc(e);
}
function ic(e, t) {
  return Ei(e, t, Si({
    transport: tc(e)
  }));
}
function oc(e, t) {
  return Ei(e, t, Si({
    transport: rc({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var ac = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function sc(e) {
  return function() {
    var t, n = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(r) {
      var i = ac(r, 2), o = i[0], a = i[1];
      typeof a < "u" ? n[o] = String(a) : j.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), n;
  };
}
var Ze = function() {
  return Ze = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ze.apply(this, arguments);
};
function uc(e, t, n) {
  var r = Ze({}, n()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, r);
  };
}
function cc(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function lc(e, t, n) {
  var r, i, o, a;
  return Ze(Ze({}, hu(e, t, n)), { headers: uc(sc(e.headers), t.headers, n.headers), url: (i = (r = cc(e.url)) !== null && r !== void 0 ? r : t.url) !== null && i !== void 0 ? i : n.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : n.agentOptions });
}
function fc(e, t) {
  return Ze(Ze({}, pu()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function _c(e, t, n) {
  return lc(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: du(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    fc(n, t)
  );
}
function dc(e, t, n, r) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = _c(e, n, r);
  return i ? ic(o, t) : oc(o, t);
}
var hc = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), pc = (
  /** @class */
  function(e) {
    hc(t, e);
    function t(n) {
      return n === void 0 && (n = {}), e.call(this, dc(n, Vu, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(lu)
);
// @__NO_SIDE_EFFECTS__
function Ec(e) {
  let t = {};
  const n = e.length;
  for (let r = 0; r < n; r++) {
    const i = e[r];
    i && (t[String(i).toUpperCase().replace(/[-.]/g, "_")] = i);
  }
  return t;
}
const Tc = "http.url", vc = "http.user_agent", fn = Tc, yc = vc, gc = "cloud.provider", mc = "cloud.account.id", Sc = "cloud.region", Oc = "cloud.availability_zone", Rc = "cloud.platform", Ac = "aws.ecs.container.arn", Pc = "aws.ecs.cluster.arn", bc = "aws.ecs.launchtype", Lc = "aws.ecs.task.arn", wc = "aws.ecs.task.family", Nc = "aws.ecs.task.revision", Cc = "aws.eks.cluster.arn", Mc = "aws.log.group.names", Ic = "aws.log.group.arns", Dc = "aws.log.stream.names", kc = "aws.log.stream.arns", xc = "container.name", Uc = "container.id", Hc = "container.runtime", Bc = "container.image.name", Gc = "container.image.tag", jc = "deployment.environment", Vc = "device.id", Fc = "device.model.identifier", Xc = "device.model.name", Zc = "faas.name", $c = "faas.id", zc = "faas.version", Wc = "faas.instance", Kc = "faas.max_memory", Yc = "host.id", qc = "host.name", Qc = "host.type", Jc = "host.arch", el = "host.image.name", tl = "host.image.id", nl = "host.image.version", rl = "k8s.cluster.name", il = "k8s.node.name", ol = "k8s.node.uid", al = "k8s.namespace.name", sl = "k8s.pod.uid", ul = "k8s.pod.name", cl = "k8s.container.name", ll = "k8s.replicaset.uid", fl = "k8s.replicaset.name", _l = "k8s.deployment.uid", dl = "k8s.deployment.name", hl = "k8s.statefulset.uid", pl = "k8s.statefulset.name", El = "k8s.daemonset.uid", Tl = "k8s.daemonset.name", vl = "k8s.job.uid", yl = "k8s.job.name", gl = "k8s.cronjob.uid", ml = "k8s.cronjob.name", Sl = "os.type", Ol = "os.description", Rl = "os.name", Al = "os.version", Pl = "process.pid", bl = "process.executable.name", Ll = "process.executable.path", wl = "process.command", Nl = "process.command_line", Cl = "process.command_args", Ml = "process.owner", Il = "process.runtime.name", Dl = "process.runtime.version", kl = "process.runtime.description", xl = "service.name", Ul = "service.namespace", Hl = "service.instance.id", Bl = "service.version", Gl = "telemetry.sdk.name", jl = "telemetry.sdk.language", Vl = "telemetry.sdk.version", Fl = "telemetry.auto.version", Xl = "webengine.name", Zl = "webengine.version", $l = "webengine.description", gr = /* @__PURE__ */ Ec([
  gc,
  mc,
  Sc,
  Oc,
  Rc,
  Ac,
  Pc,
  bc,
  Lc,
  wc,
  Nc,
  Cc,
  Mc,
  Ic,
  Dc,
  kc,
  xc,
  Uc,
  Hc,
  Bc,
  Gc,
  jc,
  Vc,
  Fc,
  Xc,
  Zc,
  $c,
  zc,
  Wc,
  Kc,
  Yc,
  qc,
  Qc,
  Jc,
  el,
  tl,
  nl,
  rl,
  il,
  ol,
  al,
  sl,
  ul,
  cl,
  ll,
  fl,
  _l,
  dl,
  hl,
  pl,
  El,
  Tl,
  vl,
  yl,
  gl,
  ml,
  Sl,
  Ol,
  Rl,
  Al,
  Pl,
  bl,
  Ll,
  wl,
  Nl,
  Cl,
  Ml,
  Il,
  Dl,
  kl,
  xl,
  Ul,
  Hl,
  Bl,
  Gl,
  jl,
  Vl,
  Fl,
  Xl,
  Zl,
  $l
]);
var Oi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), zl = new Oi(), Wl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, n, r) {
      return new Oi();
    }, e;
  }()
), Ri = new Wl(), Kl = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      this._provider = t, this.name = n, this.version = r, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : zl;
    }, e;
  }()
), mr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, n, r) {
      var i;
      return (i = this.getDelegateLogger(t, n, r)) !== null && i !== void 0 ? i : new Kl(this, t, n, r);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Ri;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, n, r) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, n, r);
    }, e;
  }()
), Yl = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Pt = Symbol.for("io.opentelemetry.js.api.logs"), ot = Yl;
function ql(e, t, n) {
  return function(r) {
    return r === e ? t : n;
  };
}
var Sr = 1, Ql = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new mr();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return ot[Pt] ? this.getLoggerProvider() : (ot[Pt] = ql(Sr, t, Ri), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, n;
      return (n = (t = ot[Pt]) === null || t === void 0 ? void 0 : t.call(ot, Sr)) !== null && n !== void 0 ? n : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, n, r) {
      return this.getLoggerProvider().getLogger(t, n, r);
    }, e.prototype.disable = function() {
      delete ot[Pt], this._proxyLoggerProvider = new mr();
    }, e;
  }()
), Ai = Ql.getInstance();
function Jl(e, t, n, r) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), n && a.setMeterProvider(n), r && a.setLoggerProvider && a.setLoggerProvider(r), a.getConfig().enabled || a.enable();
  }
}
function ef(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function tf(e) {
  var t, n, r = e.tracerProvider || Q.getTracerProvider(), i = e.meterProvider || Xr.getMeterProvider(), o = e.loggerProvider || Ai.getLoggerProvider(), a = (n = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && n !== void 0 ? n : [];
  return Jl(a, r, i, o), function() {
    ef(a);
  };
}
function Sn(e) {
  return typeof e == "function";
}
var ue = console.error.bind(console);
function at(e, t, n) {
  var r = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: r,
    writable: !0,
    value: n
  });
}
function gt(e) {
  e && e.logger && (Sn(e.logger) ? ue = e.logger : ue("new logger isn't a function, not replacing"));
}
function Pi(e, t, n) {
  if (!e || !e[t]) {
    ue("no original function " + t + " to wrap");
    return;
  }
  if (!n) {
    ue("no wrapper function"), ue(new Error().stack);
    return;
  }
  if (!Sn(e[t]) || !Sn(n)) {
    ue("original object and wrapper must be functions");
    return;
  }
  var r = e[t], i = n(r, t);
  return at(i, "__original", r), at(i, "__unwrap", function() {
    e[t] === i && at(e, t, r);
  }), at(i, "__wrapped", !0), at(e, t, i), i;
}
function nf(e, t, n) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    ue("must provide one or more modules to patch"), ue(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    ue("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(i) {
      Pi(r, i, n);
    });
  });
}
function bi(e, t) {
  if (!e || !e[t]) {
    ue("no function to unwrap."), ue(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    ue("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function rf(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    ue("must provide one or more modules to patch"), ue(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    ue("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(r) {
      bi(n, r);
    });
  });
}
gt.wrap = Pi;
gt.massWrap = nf;
gt.unwrap = bi;
gt.massUnwrap = rf;
var bt = gt, On = function() {
  return On = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, On.apply(this, arguments);
}, of = (
  /** @class */
  function() {
    function e(t, n, r) {
      this.instrumentationName = t, this.instrumentationVersion = n, this._config = {}, this._wrap = bt.wrap, this._unwrap = bt.unwrap, this._massWrap = bt.massWrap, this._massUnwrap = bt.massUnwrap, this.setConfig(r), this._diag = j.createComponentLogger({
        namespace: t
      }), this._tracer = Q.getTracer(t, n), this._meter = Xr.getMeter(t, n), this._logger = Ai.getLogger(t, n), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, n = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(n) ? n : [n];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = On({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, n, r, i) {
      if (t)
        try {
          t(r, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: n }, o);
        }
    }, e;
  }()
), af = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), $t = (
  /** @class */
  function(e) {
    af(t, e);
    function t(n, r, i) {
      var o = e.call(this, n, r, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(of)
);
function Bt(e, t, n) {
  var r, i;
  try {
    i = e();
  } catch (o) {
    r = o;
  } finally {
    return t(r, i), i;
  }
}
function oe(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Gt;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(Gt || (Gt = {}));
var sf = "http.method", uf = "http.url", cf = "http.host", lf = "http.scheme", ff = "http.status_code", _f = "http.user_agent", df = "http.request_content_length_uncompressed", hf = sf, pf = uf, Ef = cf, Tf = lf, vf = ff, yf = _f, gf = df, mf = function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}, Sf = function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Of = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rf = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Li = j.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Af() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var n = e[1];
    if (!(n != null && n.body))
      return Promise.resolve();
    if (n.body instanceof ReadableStream) {
      var r = Pf(n.body), i = r.body, o = r.length;
      return n.body = i, o;
    } else
      return Promise.resolve(bf(n.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(s) {
      return Rn(s);
    }) : Promise.resolve();
  }
}
function Pf(e) {
  if (!e.pipeThrough)
    return Li.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, n, r = new Promise(function(o) {
    n = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return mf(this, void 0, void 0, function() {
        var s;
        return Sf(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return s = c.sent(), t += s.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      n(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: r
  };
}
function bf(e) {
  if (typeof Document < "u" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return wf(e);
  if (e instanceof URLSearchParams)
    return Rn(e.toString());
  if (typeof e == "string")
    return Rn(e);
  Li.warn("unknown body type");
}
var Lf = new TextEncoder();
function Rn(e) {
  return Lf.encode(e).byteLength;
}
function wf(e) {
  var t, n, r = 0;
  try {
    for (var i = Of(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Rf(o.value, 2), s = a[0], c = a[1];
      r += s.length, c instanceof Blob ? r += c.size : r += c.length;
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
var Or = "0.57.2", Nf = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Cf = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Mf = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}, _n, If = 300, Rr = typeof process == "object" && ((_n = process.release) === null || _n === void 0 ? void 0 : _n.name) === "node", Df = (
  /** @class */
  function(e) {
    Nf(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, "@opentelemetry/instrumentation-fetch", Or, n) || this;
      return r.component = "fetch", r.version = Or, r.moduleName = r.component, r._usedResources = /* @__PURE__ */ new WeakSet(), r._tasksCount = 0, r;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(n, r) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: r[D.FETCH_START]
      }, Q.setSpan(F.active(), n));
      et(i, r, this.getConfig().ignoreNetworkEvents), i.end(r[D.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(n, r) {
      var i = Le(r.url);
      n.setAttribute(vf, r.status), r.statusText != null && n.setAttribute(Gt.HTTP_STATUS_TEXT, r.statusText), n.setAttribute(Ef, i.host), n.setAttribute(Tf, i.protocol.replace(":", "")), typeof navigator < "u" && n.setAttribute(yf, navigator.userAgent);
    }, t.prototype._addHeaders = function(n, r) {
      if (!pi(r, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        de.inject(F.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (n instanceof Request)
        de.inject(F.active(), n.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (n.headers instanceof Headers)
        de.inject(F.active(), n.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (n.headers instanceof Map)
        de.inject(F.active(), n.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else {
        var i = {};
        de.inject(F.active(), i), n.headers = Object.assign({}, i, n.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(n, r) {
      var i;
      if (r === void 0 && (r = {}), si(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (r.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: ht.CLIENT,
        attributes: (i = {}, i[Gt.COMPONENT] = this.moduleName, i[hf] = o, i[pf] = n, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(n, r, i) {
      var o = r.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = di(r.spanUrl, r.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var s = a.mainRequest;
        this._markResourceAsUsed(s);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(n, c), this._markResourceAsUsed(c)), et(n, s, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(n) {
      this._usedResources.add(n);
    }, t.prototype._endSpan = function(n, r, i) {
      var o = this, a = Ce(Date.now()), s = Xe();
      this._addFinalSpanAttributes(n, i), setTimeout(function() {
        var c;
        (c = r.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(n, r, s), o._tasksCount--, o._clearResources(), n.end(a);
      }, If);
    }, t.prototype._patchConstructor = function() {
      var n = this;
      return function(r) {
        var i = n;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var c = this, u = Le(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(u, l);
          if (!f)
            return r.apply(this, a);
          var E = i._prepareSpanData(u);
          i.getConfig().measureRequestSize && Af.apply(void 0, Mf([], Cf(a), !1)).then(function(b) {
            b && f.setAttribute(gf, b);
          }).catch(function(b) {
            i._diag.warn("getFetchBodyLength", b);
          });
          function S(b, m) {
            i._applyAttributesAfterFetch(b, l, m), i._endSpan(b, E, {
              status: m.status || 0,
              statusText: m.message,
              url: u
            });
          }
          function O(b, m) {
            i._applyAttributesAfterFetch(b, l, m), m.status >= 200 && m.status < 400 ? i._endSpan(b, E, m) : i._endSpan(b, E, {
              status: m.status,
              statusText: m.statusText,
              url: u
            });
          }
          function R(b, m, y) {
            try {
              var X = y.clone(), Z = y.clone(), q = X.body;
              if (q) {
                var K = q.getReader(), A = function() {
                  K.read().then(function(Y) {
                    var x = Y.done;
                    x ? O(b, Z) : A();
                  }, function(Y) {
                    S(b, Y);
                  });
                };
                A();
              } else
                O(b, y);
            } finally {
              m(y);
            }
          }
          function k(b, m, y) {
            try {
              S(b, y);
            } finally {
              m(y);
            }
          }
          return new Promise(function(b, m) {
            return F.with(Q.setSpan(F.active(), f), function() {
              return i._addHeaders(l, u), i._tasksCount++, r.apply(c, l instanceof Request ? [l] : [u, l]).then(R.bind(c, f, b), k.bind(c, f, m));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(n, r, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && Bt(function() {
        return a(n, r, i);
      }, function(s) {
        s && o._diag.error("applyCustomAttributesOnSpan", s);
      });
    }, t.prototype._prepareSpanData = function(n) {
      var r = Xe(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: r, spanUrl: n };
      var o = new PerformanceObserver(function(a) {
        var s = a.getEntries();
        s.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === n && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: r, spanUrl: n };
    }, t.prototype.enable = function() {
      if (Rr) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      oe(fetch) && (this._unwrap(ct, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(ct, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Rr || (this._unwrap(ct, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }($t)
), kf = "http.method", xf = "http.url", Uf = "http.host", Hf = "http.scheme", Bf = "http.status_code", Gf = "http.user_agent", jf = "http.request_content_length_uncompressed", Vf = kf, Ff = xf, Xf = Uf, Zf = Hf, $f = Bf, zf = Gf, Wf = jf, be;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(be || (be = {}));
var Kf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Yf = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, qf = j.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Qf(e) {
  if (typeof Document < "u" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return e_(e);
  if (e instanceof URLSearchParams)
    return Ar(e.toString());
  if (typeof e == "string")
    return Ar(e);
  qf.warn("unknown body type");
}
var Jf = new TextEncoder();
function Ar(e) {
  return Jf.encode(e).byteLength;
}
function e_(e) {
  var t, n, r = 0;
  try {
    for (var i = Kf(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Yf(o.value, 2), s = a[0], c = a[1];
      r += s.length, c instanceof Blob ? r += c.size : r += c.length;
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
var Pr = "0.57.2", An;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(An || (An = {}));
var t_ = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), n_ = 300, r_ = (
  /** @class */
  function(e) {
    t_(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Pr, n) || this;
      return r.component = "xml-http-request", r.version = Pr, r.moduleName = r.component, r._tasksCount = 0, r._xhrMem = /* @__PURE__ */ new WeakMap(), r._usedResources = /* @__PURE__ */ new WeakSet(), r;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(n, r) {
      var i = Le(r).href;
      if (!pi(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        de.inject(F.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      de.inject(F.active(), a), Object.keys(a).forEach(function(s) {
        n.setRequestHeader(s, String(a[s]));
      });
    }, t.prototype._addChildSpan = function(n, r) {
      var i = this;
      F.with(Q.setSpan(F.active(), n), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: r[D.FETCH_START]
        });
        et(o, r, i.getConfig().ignoreNetworkEvents), o.end(r[D.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(n, r, i) {
      if (typeof i == "string") {
        var o = Le(i);
        r.status !== void 0 && n.setAttribute($f, r.status), r.statusText !== void 0 && n.setAttribute(An.HTTP_STATUS_TEXT, r.statusText), n.setAttribute(Xf, o.host), n.setAttribute(Zf, o.protocol.replace(":", "")), n.setAttribute(zf, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(n, r) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && Bt(function() {
        return o(n, r);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(n, r) {
      var i = this._xhrMem.get(n);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), s = Le(r);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === s.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (he.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(n, r, i, o, a) {
      if (!(!i || !o || !a || !n.createdResources)) {
        var s = n.createdResources.entries;
        (!s || !s.length) && (s = he.getEntriesByType("resource"));
        var c = di(Le(i).href, o, a, s, this._usedResources);
        if (c.mainRequest) {
          var u = c.mainRequest;
          this._markResourceAsUsed(u);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(r, l), this._markResourceAsUsed(l)), et(r, u, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(n) {
      var r = this._xhrMem.get(n);
      if (r) {
        var i = r.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(n);
      }
    }, t.prototype._createSpan = function(n, r, i) {
      var o;
      if (si(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), s = this.tracer.startSpan(a, {
        kind: ht.CLIENT,
        attributes: (o = {}, o[Vf] = i, o[Ff] = Le(r).toString(), o)
      });
      return s.addEvent(be.METHOD_OPEN), this._cleanPreviousSpanInformation(n), this._xhrMem.set(n, {
        span: s,
        spanUrl: r
      }), s;
    }, t.prototype._markResourceAsUsed = function(n) {
      this._usedResources.add(n);
    }, t.prototype._patchOpen = function() {
      var n = this;
      return function(r) {
        var i = n;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var c = a[0], u = a[1];
          return i._createSpan(this, u, c), r.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var n = this;
      function r(l, f, E, S) {
        var O = f.callbackToRemoveEvents;
        typeof O == "function" && O();
        var R = f.span, k = f.spanUrl, b = f.sendStartTime;
        R && (n._findResourceAndAddNetworkEvents(f, R, k, b, E), R.addEvent(l, S), n._addFinalSpanAttributes(R, f, k), R.end(S), n._tasksCount--), n._clearResources();
      }
      function i(l, f) {
        var E = n._xhrMem.get(f);
        if (E) {
          E.status = f.status, E.statusText = f.statusText, n._xhrMem.delete(f), E.span && n._applyAttributesAfterXHR(E.span, f);
          var S = Xe(), O = Date.now();
          setTimeout(function() {
            r(l, E, S, O);
          }, n_);
        }
      }
      function o() {
        i(be.EVENT_ERROR, this);
      }
      function a() {
        i(be.EVENT_ABORT, this);
      }
      function s() {
        i(be.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(be.EVENT_LOAD, this) : i(be.EVENT_ERROR, this);
      }
      function u(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", s);
        var f = n._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var E = this, S = [], O = 0; O < arguments.length; O++)
            S[O] = arguments[O];
          var R = n._xhrMem.get(this);
          if (!R)
            return l.apply(this, S);
          var k = R.span, b = R.spanUrl;
          if (k && b) {
            if (n.getConfig().measureRequestSize && (S != null && S[0])) {
              var m = S[0], y = Qf(m);
              y !== void 0 && k.setAttribute(Wf, y);
            }
            F.with(Q.setSpan(F.active(), k), function() {
              n._tasksCount++, R.sendStartTime = Xe(), k.addEvent(be.METHOD_SEND), E.addEventListener("abort", a), E.addEventListener("error", o), E.addEventListener("load", c), E.addEventListener("timeout", s), R.callbackToRemoveEvents = function() {
                u(E), R.createdResources && R.createdResources.observer.disconnect();
              }, n._addHeaders(E, b), n._addResourceObserver(E, b);
            });
          }
          return l.apply(this, S);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), oe(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), oe(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }($t)
), ft;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(ft || (ft = {}));
var i_ = "0.44.1", o_ = "@opentelemetry/instrumentation-document-load", jt;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(jt || (jt = {}));
var a_ = function() {
  var e, t, n = {}, r = (t = (e = he).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (r) {
    var i = Object.values(D);
    i.forEach(function(s) {
      if (Be(r, s)) {
        var c = r[s];
        typeof c == "number" && (n[s] = c);
      }
    });
  } else {
    var o = he, a = o.timing;
    if (a) {
      var i = Object.values(D);
      i.forEach(function(c) {
        if (Be(a, c)) {
          var u = a[c];
          typeof u == "number" && (n[c] = u);
        }
      });
    }
  }
  return n;
}, br = {
  "first-paint": jt.FIRST_PAINT,
  "first-contentful-paint": jt.FIRST_CONTENTFUL_PAINT
}, s_ = function(e) {
  var t, n, r = (n = (t = he).getEntriesByType) === null || n === void 0 ? void 0 : n.call(t, "paint");
  r && r.forEach(function(i) {
    var o = i.name, a = i.startTime;
    Be(br, o) && e.addEvent(br[o], a);
  });
}, u_ = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), c_ = (
  /** @class */
  function(e) {
    u_(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, o_, i_, n) || this;
      return r.component = "document-load", r.version = "1", r.moduleName = r.component, r;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var n = this;
      window.setTimeout(function() {
        n._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(n) {
      var r = this, i, o, a = (o = (i = he).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(s) {
        r._initResourceSpan(s, n);
      });
    }, t.prototype._collectPerformance = function() {
      var n = this, r = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Mt;
      }), i = a_(), o = r && r.content || "";
      F.with(de.extract(Oe, { traceparent: o }), function() {
        var a, s = n._startSpan(ft.DOCUMENT_LOAD, D.FETCH_START, i);
        s && (F.with(Q.setSpan(F.active(), s), function() {
          var c = n._startSpan(ft.DOCUMENT_FETCH, D.FETCH_START, i);
          c && (c.setAttribute(fn, location.href), F.with(Q.setSpan(F.active(), c), function() {
            var u;
            n.getConfig().ignoreNetworkEvents || et(c, i), n._addCustomAttributesOnSpan(c, (u = n.getConfig().applyCustomAttributesOnSpan) === null || u === void 0 ? void 0 : u.documentFetch), n._endSpan(c, D.RESPONSE_END, i);
          }));
        }), s.setAttribute(fn, location.href), s.setAttribute(yc, navigator.userAgent), n._addResourcesSpans(s), n.getConfig().ignoreNetworkEvents || (ae(s, D.FETCH_START, i), ae(s, D.UNLOAD_EVENT_START, i), ae(s, D.UNLOAD_EVENT_END, i), ae(s, D.DOM_INTERACTIVE, i), ae(s, D.DOM_CONTENT_LOADED_EVENT_START, i), ae(s, D.DOM_CONTENT_LOADED_EVENT_END, i), ae(s, D.DOM_COMPLETE, i), ae(s, D.LOAD_EVENT_START, i), ae(s, D.LOAD_EVENT_END, i)), n.getConfig().ignorePerformancePaintEvents || s_(s), n._addCustomAttributesOnSpan(s, (a = n.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), n._endSpan(s, D.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(n, r, i) {
      n && (Be(i, r) ? n.end(i[r]) : n.end());
    }, t.prototype._initResourceSpan = function(n, r) {
      var i, o = this._startSpan(ft.RESOURCE_FETCH, D.FETCH_START, n, r);
      o && (o.setAttribute(fn, n.name), this.getConfig().ignoreNetworkEvents || et(o, n), this._addCustomAttributesOnResourceSpan(o, n, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, D.RESPONSE_END, n));
    }, t.prototype._startSpan = function(n, r, i, o) {
      if (Be(i, r) && typeof i[r] == "number") {
        var a = this.tracer.startSpan(n, {
          startTime: i[r]
        }, o ? Q.setSpan(F.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(n, r) {
      var i = this;
      r && Bt(function() {
        return r(n);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(n, r, i) {
      var o = this;
      i && Bt(function() {
        return i(n, r);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }($t)
), qe;
(function(e) {
  e.EVENT_TYPE = "event_type", e.TARGET_ELEMENT = "target_element", e.TARGET_XPATH = "target_xpath", e.HTTP_URL = "http.url";
})(qe || (qe = {}));
var Lr = "0.44.1", l_ = "@opentelemetry/instrumentation-user-interaction", f_ = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), __ = "OT_ZONE_CONTEXT", d_ = "Navigation:", h_ = ["click"];
function p_() {
  return !1;
}
var E_ = (
  /** @class */
  function(e) {
    f_(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r, i = e.call(this, l_, Lr, n) || this;
      return i.version = Lr, i.moduleName = "user-interaction", i._spansData = /* @__PURE__ */ new WeakMap(), i._wrappedListeners = /* @__PURE__ */ new WeakMap(), i._eventsSpanMap = /* @__PURE__ */ new WeakMap(), i._eventNames = new Set((r = n == null ? void 0 : n.eventNames) !== null && r !== void 0 ? r : h_), i._shouldPreventSpanCreation = typeof (n == null ? void 0 : n.shouldPreventSpanCreation) == "function" ? n.shouldPreventSpanCreation : p_, i;
    }
    return t.prototype.init = function() {
    }, t.prototype._checkForTimeout = function(n, r) {
      var i = this._spansData.get(r);
      i && (n.source === "setTimeout" ? i.hrTimeLastTimeout = Xe() : n.source !== "Promise.then" && n.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
    }, t.prototype._allowEventName = function(n) {
      return this._eventNames.has(n);
    }, t.prototype._createSpan = function(n, r, i) {
      var o;
      if (n instanceof HTMLElement && n.getAttribute && !n.hasAttribute("disabled") && this._allowEventName(r)) {
        var a = hi(n, !0);
        try {
          var s = this.tracer.startSpan(r, {
            attributes: (o = {}, o[qe.EVENT_TYPE] = r, o[qe.TARGET_ELEMENT] = n.tagName, o[qe.TARGET_XPATH] = a, o[qe.HTTP_URL] = window.location.href, o)
          }, i ? Q.setSpan(F.active(), i) : void 0);
          return this._shouldPreventSpanCreation(r, n, s) === !0 ? void 0 : (this._spansData.set(s, {
            taskCount: 0
          }), s);
        } catch (c) {
          this._diag.error("failed to start create new user interaction span", c);
        }
      }
    }, t.prototype._decrementTask = function(n) {
      var r = this._spansData.get(n);
      r && (r.taskCount--, r.taskCount === 0 && this._tryToEndSpan(n, r.hrTimeLastTimeout));
    }, t.prototype._getCurrentSpan = function(n) {
      var r = n.get(__);
      return r && Q.getSpan(r);
    }, t.prototype._incrementTask = function(n) {
      var r = this._spansData.get(n);
      r && r.taskCount++;
    }, t.prototype.addPatchedListener = function(n, r, i, o) {
      var a = this._wrappedListeners.get(i);
      a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
      var s = a.get(r);
      return s || (s = /* @__PURE__ */ new Map(), a.set(r, s)), s.has(n) ? !1 : (s.set(n, o), !0);
    }, t.prototype.removePatchedListener = function(n, r, i) {
      var o = this._wrappedListeners.get(i);
      if (o) {
        var a = o.get(r);
        if (a) {
          var s = a.get(n);
          return s && (a.delete(n), a.size === 0 && (o.delete(r), o.size === 0 && this._wrappedListeners.delete(i))), s;
        }
      }
    }, t.prototype._invokeListener = function(n, r, i) {
      return typeof n == "function" ? n.apply(r, i) : n.handleEvent(i[0]);
    }, t.prototype._patchAddEventListener = function() {
      var n = this;
      return function(r) {
        return function(o, a, s) {
          if (!a)
            return r.call(this, o, a, s);
          var c = s && typeof s == "object" && s.once, u = function() {
            for (var l = this, f = [], E = 0; E < arguments.length; E++)
              f[E] = arguments[E];
            var S, O = f[0], R = O == null ? void 0 : O.target;
            O && (S = n._eventsSpanMap.get(O)), c && n.removePatchedListener(this, o, a);
            var k = n._createSpan(R, o, S);
            return k ? (O && n._eventsSpanMap.set(O, k), F.with(Q.setSpan(F.active(), k), function() {
              var b = n._invokeListener(a, l, f);
              return k.end(), b;
            })) : n._invokeListener(a, this, f);
          };
          if (n.addPatchedListener(this, o, a, u))
            return r.call(this, o, u, s);
        };
      };
    }, t.prototype._patchRemoveEventListener = function() {
      var n = this;
      return function(r) {
        return function(o, a, s) {
          var c = n.removePatchedListener(this, o, a);
          return c ? r.call(this, o, c, s) : r.call(this, o, a, s);
        };
      };
    }, t.prototype._getPatchableEventTargets = function() {
      return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
    }, t.prototype._patchHistoryApi = function() {
      this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
    }, t.prototype._patchHistoryMethod = function() {
      var n = this;
      return function(r) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var s = "" + location.pathname + location.hash + location.search, c = r.apply(this, o), u = "" + location.pathname + location.hash + location.search;
          return s !== u && n._updateInteractionName(u), c;
        };
      };
    }, t.prototype._unpatchHistoryApi = function() {
      oe(history.replaceState) && this._unwrap(history, "replaceState"), oe(history.pushState) && this._unwrap(history, "pushState"), oe(history.back) && this._unwrap(history, "back"), oe(history.forward) && this._unwrap(history, "forward"), oe(history.go) && this._unwrap(history, "go");
    }, t.prototype._updateInteractionName = function(n) {
      var r = Q.getSpan(F.active());
      r && typeof r.updateName == "function" && r.updateName(d_ + " " + n);
    }, t.prototype._patchZoneCancelTask = function() {
      var n = this;
      return function(r) {
        return function(o) {
          var a = Zone.current, s = n._getCurrentSpan(a);
          return s && n._shouldCountTask(o, a) && n._decrementTask(s), r.call(this, o);
        };
      };
    }, t.prototype._patchZoneScheduleTask = function() {
      var n = this;
      return function(r) {
        return function(o) {
          var a = Zone.current, s = n._getCurrentSpan(a);
          return s && n._shouldCountTask(o, a) && (n._incrementTask(s), n._checkForTimeout(o, s)), r.call(this, o);
        };
      };
    }, t.prototype._patchZoneRunTask = function() {
      var n = this;
      return function(r) {
        return function(o, a, s) {
          var c = Array.isArray(s) && s[0] instanceof Event ? s[0] : void 0, u = c == null ? void 0 : c.target, l, f = this;
          if (u) {
            if (l = n._createSpan(u, o.eventName), l)
              return n._incrementTask(l), f.run(function() {
                try {
                  return F.with(Q.setSpan(F.active(), l), function() {
                    var E = Zone.current;
                    return o._zone = E, r.call(E, o, a, s);
                  });
                } finally {
                  n._decrementTask(l);
                }
              });
          } else
            l = n._getCurrentSpan(f);
          try {
            return r.call(f, o, a, s);
          } finally {
            l && n._shouldCountTask(o, f) && n._decrementTask(l);
          }
        };
      };
    }, t.prototype._shouldCountTask = function(n, r) {
      if (n._zone && (r = n._zone), !r || !n.data || n.data.isPeriodic)
        return !1;
      var i = this._getCurrentSpan(r);
      return !i || !this._spansData.get(i) ? !1 : n.type === "macroTask" || n.type === "microTask";
    }, t.prototype._tryToEndSpan = function(n, r) {
      if (n) {
        var i = this._spansData.get(n);
        i && (n.end(r), this._spansData.delete(n));
      }
    }, t.prototype.enable = function() {
      var n = this, r = this._getZoneWithPrototype();
      if (this._diag.debug("applying patch to", this.moduleName, this.version, "zone:", !!r), r)
        oe(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), oe(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug("removing previous patch from method scheduleTask")), oe(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug("removing previous patch from method cancelTask")), this._zonePatched = !0, this._wrap(r.prototype, "runTask", this._patchZoneRunTask()), this._wrap(r.prototype, "scheduleTask", this._patchZoneScheduleTask()), this._wrap(r.prototype, "cancelTask", this._patchZoneCancelTask());
      else {
        this._zonePatched = !1;
        var i = this._getPatchableEventTargets();
        i.forEach(function(o) {
          oe(o.addEventListener) && (n._unwrap(o, "addEventListener"), n._diag.debug("removing previous patch from method addEventListener")), oe(o.removeEventListener) && (n._unwrap(o, "removeEventListener"), n._diag.debug("removing previous patch from method removeEventListener")), n._wrap(o, "addEventListener", n._patchAddEventListener()), n._wrap(o, "removeEventListener", n._patchRemoveEventListener());
        });
      }
      this._patchHistoryApi();
    }, t.prototype.disable = function() {
      var n = this, r = this._getZoneWithPrototype();
      if (this._diag.debug("removing patch from", this.moduleName, this.version, "zone:", !!r), r && this._zonePatched)
        oe(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), oe(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), oe(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask");
      else {
        var i = this._getPatchableEventTargets();
        i.forEach(function(o) {
          oe(o.addEventListener) && n._unwrap(o, "addEventListener"), oe(o.removeEventListener) && n._unwrap(o, "removeEventListener");
        });
      }
      this._unpatchHistoryApi();
    }, t.prototype._getZoneWithPrototype = function() {
      var n = window;
      return n.Zone;
    }, t;
  }($t)
);
function T_(e) {
  return e === void 0 && (e = {}), typeof e.addEventListener == "function" && typeof e.removeEventListener == "function";
}
var wr = "OT_ZONE_CONTEXT", v_ = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._zoneCounter = 0;
    }
    return e.prototype._activeContextFromZone = function(t) {
      return t && t.get(wr) || Oe;
    }, e.prototype._bindFunction = function(t, n) {
      var r = this, i = function() {
        for (var o = this, a = [], s = 0; s < arguments.length; s++)
          a[s] = arguments[s];
        return r.with(t, function() {
          return n.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: n.length
      }), i;
    }, e.prototype._bindListener = function(t, n) {
      var r = n;
      return r.__ot_listeners !== void 0 || (r.__ot_listeners = {}, typeof r.addEventListener == "function" && (r.addEventListener = this._patchAddEventListener(r, r.addEventListener, t)), typeof r.removeEventListener == "function" && (r.removeEventListener = this._patchRemoveEventListener(r, r.removeEventListener))), n;
    }, e.prototype._createZoneName = function() {
      this._zoneCounter++;
      var t = Math.random();
      return this._zoneCounter + "-" + t;
    }, e.prototype._createZone = function(t, n) {
      var r;
      return Zone.current.fork({
        name: t,
        properties: (r = {}, r[wr] = n, r)
      });
    }, e.prototype._getActiveZone = function() {
      return Zone.current;
    }, e.prototype._patchAddEventListener = function(t, n, r) {
      var i = this;
      return function(o, a, s) {
        t.__ot_listeners === void 0 && (t.__ot_listeners = {});
        var c = t.__ot_listeners[o];
        c === void 0 && (c = /* @__PURE__ */ new WeakMap(), t.__ot_listeners[o] = c);
        var u = i.bind(r, a);
        return c.set(a, u), n.call(this, o, u, s);
      };
    }, e.prototype._patchRemoveEventListener = function(t, n) {
      return function(r, i) {
        if (t.__ot_listeners === void 0 || t.__ot_listeners[r] === void 0)
          return n.call(this, r, i);
        var o = t.__ot_listeners[r], a = o.get(i);
        return o.delete(i), n.call(this, r, a || i);
      };
    }, e.prototype.active = function() {
      if (!this._enabled)
        return Oe;
      var t = this._getActiveZone(), n = this._activeContextFromZone(t);
      return n || Oe;
    }, e.prototype.bind = function(t, n) {
      return t === void 0 && (t = this.active()), typeof n == "function" ? this._bindFunction(t, n) : (T_(n) && this._bindListener(t, n), n);
    }, e.prototype.disable = function() {
      return this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled = !0, this;
    }, e.prototype.with = function(t, n, r) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._createZoneName(), s = this._createZone(a, t);
      return s.run(n, r, i);
    }, e;
  }()
);
/**
 * @license Angular v<unknown>
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */
const me = globalThis;
function fe(e) {
  return (me.__Zone_symbol_prefix || "__zone_symbol__") + e;
}
function y_() {
  const e = me.performance;
  function t(z) {
    e && e.mark && e.mark(z);
  }
  function n(z, p) {
    e && e.measure && e.measure(z, p);
  }
  t("Zone");
  const re = class re {
    constructor(p, d) {
      I(this, "_parent");
      I(this, "_name");
      I(this, "_properties");
      I(this, "_zoneDelegate");
      this._parent = p, this._name = d ? d.name || "unnamed" : "<root>", this._properties = d && d.properties || {}, this._zoneDelegate = new o(this, this._parent && this._parent._zoneDelegate, d);
    }
    static assertZonePatched() {
      if (me.Promise !== x.ZoneAwarePromise)
        throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
    }
    static get root() {
      let p = re.current;
      for (; p.parent; )
        p = p.parent;
      return p;
    }
    static get current() {
      return N.zone;
    }
    static get currentTask() {
      return U;
    }
    static __load_patch(p, d, _ = !1) {
      if (x.hasOwnProperty(p)) {
        const L = me[fe("forceDuplicateZoneCheck")] === !0;
        if (!_ && L)
          throw Error("Already loaded patch: " + p);
      } else if (!me["__Zone_disable_" + p]) {
        const L = "Zone:" + p;
        t(L), x[p] = d(me, re, M), n(L, L);
      }
    }
    get parent() {
      return this._parent;
    }
    get name() {
      return this._name;
    }
    get(p) {
      const d = this.getZoneWith(p);
      if (d)
        return d._properties[p];
    }
    getZoneWith(p) {
      let d = this;
      for (; d; ) {
        if (d._properties.hasOwnProperty(p))
          return d;
        d = d._parent;
      }
      return null;
    }
    fork(p) {
      if (!p)
        throw new Error("ZoneSpec required!");
      return this._zoneDelegate.fork(this, p);
    }
    wrap(p, d) {
      if (typeof p != "function")
        throw new Error("Expecting function got: " + p);
      const _ = this._zoneDelegate.intercept(this, p, d), L = this;
      return function() {
        return L.runGuarded(_, this, arguments, d);
      };
    }
    run(p, d, _, L) {
      N = { parent: N, zone: this };
      try {
        return this._zoneDelegate.invoke(this, p, d, _, L);
      } finally {
        N = N.parent;
      }
    }
    runGuarded(p, d = null, _, L) {
      N = { parent: N, zone: this };
      try {
        try {
          return this._zoneDelegate.invoke(this, p, d, _, L);
        } catch (W) {
          if (this._zoneDelegate.handleError(this, W))
            throw W;
        }
      } finally {
        N = N.parent;
      }
    }
    runTask(p, d, _) {
      if (p.zone != this)
        throw new Error("A task can only be run in the zone of creation! (Creation: " + (p.zone || k).name + "; Execution: " + this.name + ")");
      const L = p, { type: W, data: { isPeriodic: V = !1, isRefreshable: ye = !1 } = {} } = p;
      if (p.state === b && (W === Y || W === A))
        return;
      const Ae = p.state != X;
      Ae && L._transitionTo(X, y);
      const Pe = U;
      U = L, N = { parent: N, zone: this };
      try {
        W == A && p.data && !V && !ye && (p.cancelFn = void 0);
        try {
          return this._zoneDelegate.invokeTask(this, L, d, _);
        } catch (Ee) {
          if (this._zoneDelegate.handleError(this, Ee))
            throw Ee;
        }
      } finally {
        const Ee = p.state;
        if (Ee !== b && Ee !== q)
          if (W == Y || V || ye && Ee === m)
            Ae && L._transitionTo(y, X, m);
          else {
            const g = L._zoneDelegates;
            this._updateTaskCount(L, -1), Ae && L._transitionTo(b, X, b), ye && (L._zoneDelegates = g);
          }
        N = N.parent, U = Pe;
      }
    }
    scheduleTask(p) {
      if (p.zone && p.zone !== this) {
        let _ = this;
        for (; _; ) {
          if (_ === p.zone)
            throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${p.zone.name}`);
          _ = _.parent;
        }
      }
      p._transitionTo(m, b);
      const d = [];
      p._zoneDelegates = d, p._zone = this;
      try {
        p = this._zoneDelegate.scheduleTask(this, p);
      } catch (_) {
        throw p._transitionTo(q, m, b), this._zoneDelegate.handleError(this, _), _;
      }
      return p._zoneDelegates === d && this._updateTaskCount(p, 1), p.state == m && p._transitionTo(y, m), p;
    }
    scheduleMicroTask(p, d, _, L) {
      return this.scheduleTask(new a(K, p, d, _, L, void 0));
    }
    scheduleMacroTask(p, d, _, L, W) {
      return this.scheduleTask(new a(A, p, d, _, L, W));
    }
    scheduleEventTask(p, d, _, L, W) {
      return this.scheduleTask(new a(Y, p, d, _, L, W));
    }
    cancelTask(p) {
      if (p.zone != this)
        throw new Error("A task can only be cancelled in the zone of creation! (Creation: " + (p.zone || k).name + "; Execution: " + this.name + ")");
      if (!(p.state !== y && p.state !== X)) {
        p._transitionTo(Z, y, X);
        try {
          this._zoneDelegate.cancelTask(this, p);
        } catch (d) {
          throw p._transitionTo(q, Z), this._zoneDelegate.handleError(this, d), d;
        }
        return this._updateTaskCount(p, -1), p._transitionTo(b, Z), p.runCount = -1, p;
      }
    }
    _updateTaskCount(p, d) {
      const _ = p._zoneDelegates;
      d == -1 && (p._zoneDelegates = null);
      for (let L = 0; L < _.length; L++)
        _[L]._updateTaskCount(p.type, d);
    }
  };
  I(re, "__symbol__", fe);
  let r = re;
  const i = {
    name: "",
    onHasTask: (z, p, d, _) => z.hasTask(d, _),
    onScheduleTask: (z, p, d, _) => z.scheduleTask(d, _),
    onInvokeTask: (z, p, d, _, L, W) => z.invokeTask(d, _, L, W),
    onCancelTask: (z, p, d, _) => z.cancelTask(d, _)
  };
  class o {
    constructor(p, d, _) {
      I(this, "_zone");
      I(this, "_taskCounts", {
        microTask: 0,
        macroTask: 0,
        eventTask: 0
      });
      I(this, "_parentDelegate");
      I(this, "_forkDlgt");
      I(this, "_forkZS");
      I(this, "_forkCurrZone");
      I(this, "_interceptDlgt");
      I(this, "_interceptZS");
      I(this, "_interceptCurrZone");
      I(this, "_invokeDlgt");
      I(this, "_invokeZS");
      I(this, "_invokeCurrZone");
      I(this, "_handleErrorDlgt");
      I(this, "_handleErrorZS");
      I(this, "_handleErrorCurrZone");
      I(this, "_scheduleTaskDlgt");
      I(this, "_scheduleTaskZS");
      I(this, "_scheduleTaskCurrZone");
      I(this, "_invokeTaskDlgt");
      I(this, "_invokeTaskZS");
      I(this, "_invokeTaskCurrZone");
      I(this, "_cancelTaskDlgt");
      I(this, "_cancelTaskZS");
      I(this, "_cancelTaskCurrZone");
      I(this, "_hasTaskDlgt");
      I(this, "_hasTaskDlgtOwner");
      I(this, "_hasTaskZS");
      I(this, "_hasTaskCurrZone");
      this._zone = p, this._parentDelegate = d, this._forkZS = _ && (_ && _.onFork ? _ : d._forkZS), this._forkDlgt = _ && (_.onFork ? d : d._forkDlgt), this._forkCurrZone = _ && (_.onFork ? this._zone : d._forkCurrZone), this._interceptZS = _ && (_.onIntercept ? _ : d._interceptZS), this._interceptDlgt = _ && (_.onIntercept ? d : d._interceptDlgt), this._interceptCurrZone = _ && (_.onIntercept ? this._zone : d._interceptCurrZone), this._invokeZS = _ && (_.onInvoke ? _ : d._invokeZS), this._invokeDlgt = _ && (_.onInvoke ? d : d._invokeDlgt), this._invokeCurrZone = _ && (_.onInvoke ? this._zone : d._invokeCurrZone), this._handleErrorZS = _ && (_.onHandleError ? _ : d._handleErrorZS), this._handleErrorDlgt = _ && (_.onHandleError ? d : d._handleErrorDlgt), this._handleErrorCurrZone = _ && (_.onHandleError ? this._zone : d._handleErrorCurrZone), this._scheduleTaskZS = _ && (_.onScheduleTask ? _ : d._scheduleTaskZS), this._scheduleTaskDlgt = _ && (_.onScheduleTask ? d : d._scheduleTaskDlgt), this._scheduleTaskCurrZone = _ && (_.onScheduleTask ? this._zone : d._scheduleTaskCurrZone), this._invokeTaskZS = _ && (_.onInvokeTask ? _ : d._invokeTaskZS), this._invokeTaskDlgt = _ && (_.onInvokeTask ? d : d._invokeTaskDlgt), this._invokeTaskCurrZone = _ && (_.onInvokeTask ? this._zone : d._invokeTaskCurrZone), this._cancelTaskZS = _ && (_.onCancelTask ? _ : d._cancelTaskZS), this._cancelTaskDlgt = _ && (_.onCancelTask ? d : d._cancelTaskDlgt), this._cancelTaskCurrZone = _ && (_.onCancelTask ? this._zone : d._cancelTaskCurrZone), this._hasTaskZS = null, this._hasTaskDlgt = null, this._hasTaskDlgtOwner = null, this._hasTaskCurrZone = null;
      const L = _ && _.onHasTask, W = d && d._hasTaskZS;
      (L || W) && (this._hasTaskZS = L ? _ : i, this._hasTaskDlgt = d, this._hasTaskDlgtOwner = this, this._hasTaskCurrZone = this._zone, _.onScheduleTask || (this._scheduleTaskZS = i, this._scheduleTaskDlgt = d, this._scheduleTaskCurrZone = this._zone), _.onInvokeTask || (this._invokeTaskZS = i, this._invokeTaskDlgt = d, this._invokeTaskCurrZone = this._zone), _.onCancelTask || (this._cancelTaskZS = i, this._cancelTaskDlgt = d, this._cancelTaskCurrZone = this._zone));
    }
    get zone() {
      return this._zone;
    }
    fork(p, d) {
      return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, p, d) : new r(p, d);
    }
    intercept(p, d, _) {
      return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, p, d, _) : d;
    }
    invoke(p, d, _, L, W) {
      return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, p, d, _, L, W) : d.apply(_, L);
    }
    handleError(p, d) {
      return this._handleErrorZS ? this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, p, d) : !0;
    }
    scheduleTask(p, d) {
      let _ = d;
      if (this._scheduleTaskZS)
        this._hasTaskZS && _._zoneDelegates.push(this._hasTaskDlgtOwner), _ = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, p, d), _ || (_ = d);
      else if (d.scheduleFn)
        d.scheduleFn(d);
      else if (d.type == K)
        O(d);
      else
        throw new Error("Task is missing scheduleFn.");
      return _;
    }
    invokeTask(p, d, _, L) {
      return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, p, d, _, L) : d.callback.apply(_, L);
    }
    cancelTask(p, d) {
      let _;
      if (this._cancelTaskZS)
        _ = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, p, d);
      else {
        if (!d.cancelFn)
          throw Error("Task is not cancelable");
        _ = d.cancelFn(d);
      }
      return _;
    }
    hasTask(p, d) {
      try {
        this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, p, d);
      } catch (_) {
        this.handleError(p, _);
      }
    }
    _updateTaskCount(p, d) {
      const _ = this._taskCounts, L = _[p], W = _[p] = L + d;
      if (W < 0)
        throw new Error("More tasks executed then were scheduled.");
      if (L == 0 || W == 0) {
        const V = {
          microTask: _.microTask > 0,
          macroTask: _.macroTask > 0,
          eventTask: _.eventTask > 0,
          change: p
        };
        this.hasTask(this._zone, V);
      }
    }
  }
  class a {
    constructor(p, d, _, L, W, V) {
      I(this, "type");
      I(this, "source");
      I(this, "invoke");
      I(this, "callback");
      I(this, "data");
      I(this, "scheduleFn");
      I(this, "cancelFn");
      I(this, "_zone", null);
      I(this, "runCount", 0);
      I(this, "_zoneDelegates", null);
      I(this, "_state", "notScheduled");
      if (this.type = p, this.source = d, this.data = L, this.scheduleFn = W, this.cancelFn = V, !_)
        throw new Error("callback is not defined");
      this.callback = _;
      const ye = this;
      p === Y && L && L.useG ? this.invoke = a.invokeTask : this.invoke = function() {
        return a.invokeTask.call(me, ye, this, arguments);
      };
    }
    static invokeTask(p, d, _) {
      p || (p = this), se++;
      try {
        return p.runCount++, p.zone.runTask(p, d, _);
      } finally {
        se == 1 && R(), se--;
      }
    }
    get zone() {
      return this._zone;
    }
    get state() {
      return this._state;
    }
    cancelScheduleRequest() {
      this._transitionTo(b, m);
    }
    _transitionTo(p, d, _) {
      if (this._state === d || this._state === _)
        this._state = p, p == b && (this._zoneDelegates = null);
      else
        throw new Error(`${this.type} '${this.source}': can not transition to '${p}', expecting state '${d}'${_ ? " or '" + _ + "'" : ""}, was '${this._state}'.`);
    }
    toString() {
      return this.data && typeof this.data.handleId < "u" ? this.data.handleId.toString() : Object.prototype.toString.call(this);
    }
    // add toJSON method to prevent cyclic error when
    // call JSON.stringify(zoneTask)
    toJSON() {
      return {
        type: this.type,
        state: this.state,
        source: this.source,
        zone: this.zone.name,
        runCount: this.runCount
      };
    }
  }
  const s = fe("setTimeout"), c = fe("Promise"), u = fe("then");
  let l = [], f = !1, E;
  function S(z) {
    if (E || me[c] && (E = me[c].resolve(0)), E) {
      let p = E[u];
      p || (p = E.then), p.call(E, z);
    } else
      me[s](z, 0);
  }
  function O(z) {
    se === 0 && l.length === 0 && S(R), z && l.push(z);
  }
  function R() {
    if (!f) {
      for (f = !0; l.length; ) {
        const z = l;
        l = [];
        for (let p = 0; p < z.length; p++) {
          const d = z[p];
          try {
            d.zone.runTask(d, null, null);
          } catch (_) {
            M.onUnhandledError(_);
          }
        }
      }
      M.microtaskDrainDone(), f = !1;
    }
  }
  const k = { name: "NO ZONE" }, b = "notScheduled", m = "scheduling", y = "scheduled", X = "running", Z = "canceling", q = "unknown", K = "microTask", A = "macroTask", Y = "eventTask", x = {}, M = {
    symbol: fe,
    currentZoneFrame: () => N,
    onUnhandledError: te,
    microtaskDrainDone: te,
    scheduleMicroTask: O,
    showUncaughtError: () => !r[fe("ignoreConsoleErrorUncaughtError")],
    patchEventTarget: () => [],
    patchOnProperties: te,
    patchMethod: () => te,
    bindArguments: () => [],
    patchThen: () => te,
    patchMacroTask: () => te,
    patchEventPrototype: () => te,
    isIEOrEdge: () => !1,
    getGlobalObjects: () => {
    },
    ObjectDefineProperty: () => te,
    ObjectGetOwnPropertyDescriptor: () => {
    },
    ObjectCreate: () => {
    },
    ArraySlice: () => [],
    patchClass: () => te,
    wrapWithCurrentZone: () => te,
    filterProperties: () => [],
    attachOriginToPatched: () => te,
    _redefineProperty: () => te,
    patchCallbacks: () => te,
    nativeScheduleMicroTask: S
  };
  let N = { parent: null, zone: new r(null, null) }, U = null, se = 0;
  function te() {
  }
  return n("Zone", "Zone"), r;
}
function g_() {
  const e = globalThis, t = e[fe("forceDuplicateZoneCheck")] === !0;
  if (e.Zone && (t || typeof e.Zone.__symbol__ != "function"))
    throw new Error("Zone already loaded.");
  return e.Zone ?? (e.Zone = y_()), e.Zone;
}
const Et = Object.getOwnPropertyDescriptor, Gn = Object.defineProperty, jn = Object.getPrototypeOf, m_ = Object.create, S_ = Array.prototype.slice, Vn = "addEventListener", Fn = "removeEventListener", dn = fe(Vn), hn = fe(Fn), we = "true", Ne = "false", Tt = fe("");
function Xn(e, t) {
  return Zone.current.wrap(e, t);
}
function Zn(e, t, n, r, i) {
  return Zone.current.scheduleMacroTask(e, t, n, r, i);
}
const $ = fe, zt = typeof window < "u", mt = zt ? window : void 0, ie = zt && mt || globalThis, O_ = "removeAttribute";
function $n(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    typeof e[n] == "function" && (e[n] = Xn(e[n], t + "_" + n));
  return e;
}
function R_(e, t) {
  const n = e.constructor.name;
  for (let r = 0; r < t.length; r++) {
    const i = t[r], o = e[i];
    if (o) {
      const a = Et(e, i);
      if (!wi(a))
        continue;
      e[i] = ((s) => {
        const c = function() {
          return s.apply(this, $n(arguments, n + "." + i));
        };
        return De(c, s), c;
      })(o);
    }
  }
}
function wi(e) {
  return e ? e.writable === !1 ? !1 : !(typeof e.get == "function" && typeof e.set > "u") : !0;
}
const Ni = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope, Wt = !("nw" in ie) && typeof ie.process < "u" && ie.process.toString() === "[object process]", zn = !Wt && !Ni && !!(zt && mt.HTMLElement), Ci = typeof ie.process < "u" && ie.process.toString() === "[object process]" && !Ni && !!(zt && mt.HTMLElement), Vt = {}, A_ = $("enable_beforeunload"), Nr = function(e) {
  if (e = e || ie.event, !e)
    return;
  let t = Vt[e.type];
  t || (t = Vt[e.type] = $("ON_PROPERTY" + e.type));
  const n = this || e.target || ie, r = n[t];
  let i;
  if (zn && n === mt && e.type === "error") {
    const o = e;
    i = r && r.call(this, o.message, o.filename, o.lineno, o.colno, o.error), i === !0 && e.preventDefault();
  } else
    i = r && r.apply(this, arguments), // https://github.com/angular/angular/issues/47579
    // https://www.w3.org/TR/2011/WD-html5-20110525/history.html#beforeunloadevent
    // This is the only specific case we should check for. The spec defines that the
    // `returnValue` attribute represents the message to show the user. When the event
    // is created, this attribute must be set to the empty string.
    e.type === "beforeunload" && // To prevent any breaking changes resulting from this change, given that
    // it was already causing a significant number of failures in G3, we have hidden
    // that behavior behind a global configuration flag. Consumers can enable this
    // flag explicitly if they want the `beforeunload` event to be handled as defined
    // in the specification.
    ie[A_] && // The IDL event definition is `attribute DOMString returnValue`, so we check whether
    // `typeof result` is a string.
    typeof i == "string" ? e.returnValue = i : i != null && !i && e.preventDefault();
  return i;
};
function Cr(e, t, n) {
  let r = Et(e, t);
  if (!r && n && Et(n, t) && (r = { enumerable: !0, configurable: !0 }), !r || !r.configurable)
    return;
  const i = $("on" + t + "patched");
  if (e.hasOwnProperty(i) && e[i])
    return;
  delete r.writable, delete r.value;
  const o = r.get, a = r.set, s = t.slice(2);
  let c = Vt[s];
  c || (c = Vt[s] = $("ON_PROPERTY" + s)), r.set = function(u) {
    let l = this;
    if (!l && e === ie && (l = ie), !l)
      return;
    typeof l[c] == "function" && l.removeEventListener(s, Nr), a == null || a.call(l, null), l[c] = u, typeof u == "function" && l.addEventListener(s, Nr, !1);
  }, r.get = function() {
    let u = this;
    if (!u && e === ie && (u = ie), !u)
      return null;
    const l = u[c];
    if (l)
      return l;
    if (o) {
      let f = o.call(this);
      if (f)
        return r.set.call(this, f), typeof u[O_] == "function" && u.removeAttribute(t), f;
    }
    return null;
  }, Gn(e, t, r), e[i] = !0;
}
function Mi(e, t, n) {
  if (t)
    for (let r = 0; r < t.length; r++)
      Cr(e, "on" + t[r], n);
  else {
    const r = [];
    for (const i in e)
      i.slice(0, 2) == "on" && r.push(i);
    for (let i = 0; i < r.length; i++)
      Cr(e, r[i], n);
  }
}
const ve = $("originalInstance");
function st(e) {
  const t = ie[e];
  if (!t)
    return;
  ie[$(e)] = t, ie[e] = function() {
    const i = $n(arguments, e);
    switch (i.length) {
      case 0:
        this[ve] = new t();
        break;
      case 1:
        this[ve] = new t(i[0]);
        break;
      case 2:
        this[ve] = new t(i[0], i[1]);
        break;
      case 3:
        this[ve] = new t(i[0], i[1], i[2]);
        break;
      case 4:
        this[ve] = new t(i[0], i[1], i[2], i[3]);
        break;
      default:
        throw new Error("Arg list too long.");
    }
  }, De(ie[e], t);
  const n = new t(function() {
  });
  let r;
  for (r in n)
    e === "XMLHttpRequest" && r === "responseBlob" || function(i) {
      typeof n[i] == "function" ? ie[e].prototype[i] = function() {
        return this[ve][i].apply(this[ve], arguments);
      } : Gn(ie[e].prototype, i, {
        set: function(o) {
          typeof o == "function" ? (this[ve][i] = Xn(o, e + "." + i), De(this[ve][i], o)) : this[ve][i] = o;
        },
        get: function() {
          return this[ve][i];
        }
      });
    }(r);
  for (r in t)
    r !== "prototype" && t.hasOwnProperty(r) && (ie[e][r] = t[r]);
}
function Ie(e, t, n) {
  let r = e;
  for (; r && !r.hasOwnProperty(t); )
    r = jn(r);
  !r && e[t] && (r = e);
  const i = $(t);
  let o = null;
  if (r && (!(o = r[i]) || !r.hasOwnProperty(i))) {
    o = r[i] = r[t];
    const a = r && Et(r, t);
    if (wi(a)) {
      const s = n(o, i, t);
      r[t] = function() {
        return s(this, arguments);
      }, De(r[t], o);
    }
  }
  return o;
}
function P_(e, t, n) {
  let r = null;
  function i(o) {
    const a = o.data;
    return a.args[a.cbIdx] = function() {
      o.invoke.apply(this, arguments);
    }, r.apply(a.target, a.args), o;
  }
  r = Ie(e, t, (o) => function(a, s) {
    const c = n(a, s);
    return c.cbIdx >= 0 && typeof s[c.cbIdx] == "function" ? Zn(c.name, s[c.cbIdx], c, i) : o.apply(a, s);
  });
}
function De(e, t) {
  e[$("OriginalDelegate")] = t;
}
let Mr = !1, pn = !1;
function b_() {
  if (Mr)
    return pn;
  Mr = !0;
  try {
    const e = mt.navigator.userAgent;
    (e.indexOf("MSIE ") !== -1 || e.indexOf("Trident/") !== -1 || e.indexOf("Edge/") !== -1) && (pn = !0);
  } catch {
  }
  return pn;
}
function Ir(e) {
  return typeof e == "function";
}
function Dr(e) {
  return typeof e == "number";
}
const L_ = {
  useG: !0
}, _e = {}, Ii = {}, Di = new RegExp("^" + Tt + "(\\w+)(true|false)$"), ki = $("propagationStopped");
function xi(e, t) {
  const n = (t ? t(e) : e) + Ne, r = (t ? t(e) : e) + we, i = Tt + n, o = Tt + r;
  _e[e] = {}, _e[e][Ne] = i, _e[e][we] = o;
}
function w_(e, t, n, r) {
  const i = r && r.add || Vn, o = r && r.rm || Fn, a = r && r.listeners || "eventListeners", s = r && r.rmAll || "removeAllListeners", c = $(i), u = "." + i + ":", l = "prependListener", f = "." + l + ":", E = function(m, y, X) {
    if (m.isRemoved)
      return;
    const Z = m.callback;
    typeof Z == "object" && Z.handleEvent && (m.callback = (A) => Z.handleEvent(A), m.originalDelegate = Z);
    let q;
    try {
      m.invoke(m, y, [X]);
    } catch (A) {
      q = A;
    }
    const K = m.options;
    if (K && typeof K == "object" && K.once) {
      const A = m.originalDelegate ? m.originalDelegate : m.callback;
      y[o].call(y, X.type, A, K);
    }
    return q;
  };
  function S(m, y, X) {
    if (y = y || e.event, !y)
      return;
    const Z = m || y.target || e, q = Z[_e[y.type][X ? we : Ne]];
    if (q) {
      const K = [];
      if (q.length === 1) {
        const A = E(q[0], Z, y);
        A && K.push(A);
      } else {
        const A = q.slice();
        for (let Y = 0; Y < A.length && !(y && y[ki] === !0); Y++) {
          const x = E(A[Y], Z, y);
          x && K.push(x);
        }
      }
      if (K.length === 1)
        throw K[0];
      for (let A = 0; A < K.length; A++) {
        const Y = K[A];
        t.nativeScheduleMicroTask(() => {
          throw Y;
        });
      }
    }
  }
  const O = function(m) {
    return S(this, m, !1);
  }, R = function(m) {
    return S(this, m, !0);
  };
  function k(m, y) {
    if (!m)
      return !1;
    let X = !0;
    y && y.useG !== void 0 && (X = y.useG);
    const Z = y && y.vh;
    let q = !0;
    y && y.chkDup !== void 0 && (q = y.chkDup);
    let K = !1;
    y && y.rt !== void 0 && (K = y.rt);
    let A = m;
    for (; A && !A.hasOwnProperty(i); )
      A = jn(A);
    if (!A && m[i] && (A = m), !A || A[c])
      return !1;
    const Y = y && y.eventNameToString, x = {}, M = A[c] = A[i], N = A[$(o)] = A[o], U = A[$(a)] = A[a], se = A[$(s)] = A[s];
    let te;
    y && y.prepend && (te = A[$(y.prepend)] = A[y.prepend]);
    function re(h, v) {
      return v ? typeof h == "boolean" ? { capture: h, passive: !0 } : h ? typeof h == "object" && h.passive !== !1 ? { ...h, passive: !0 } : h : { passive: !0 } : h;
    }
    const z = function(h) {
      if (!x.isExisting)
        return M.call(x.target, x.eventName, x.capture ? R : O, x.options);
    }, p = function(h) {
      if (!h.isRemoved) {
        const v = _e[h.eventName];
        let w;
        v && (w = v[h.capture ? we : Ne]);
        const C = w && h.target[w];
        if (C) {
          for (let P = 0; P < C.length; P++)
            if (C[P] === h) {
              C.splice(P, 1), h.isRemoved = !0, h.removeAbortListener && (h.removeAbortListener(), h.removeAbortListener = null), C.length === 0 && (h.allRemoved = !0, h.target[w] = null);
              break;
            }
        }
      }
      if (h.allRemoved)
        return N.call(h.target, h.eventName, h.capture ? R : O, h.options);
    }, d = function(h) {
      return M.call(x.target, x.eventName, h.invoke, x.options);
    }, _ = function(h) {
      return te.call(x.target, x.eventName, h.invoke, x.options);
    }, L = function(h) {
      return N.call(h.target, h.eventName, h.invoke, h.options);
    }, W = X ? z : d, V = X ? p : L, ye = function(h, v) {
      const w = typeof v;
      return w === "function" && h.callback === v || w === "object" && h.originalDelegate === v;
    }, Ae = (y == null ? void 0 : y.diff) || ye, Pe = Zone[$("UNPATCHED_EVENTS")], Ee = e[$("PASSIVE_EVENTS")];
    function g(h) {
      if (typeof h == "object" && h !== null) {
        const v = { ...h };
        return h.signal && (v.signal = h.signal), v;
      }
      return h;
    }
    const T = function(h, v, w, C, P = !1, H = !1) {
      return function() {
        const B = this || e;
        let G = arguments[0];
        y && y.transferEventName && (G = y.transferEventName(G));
        let J = arguments[1];
        if (!J)
          return h.apply(this, arguments);
        if (Wt && G === "uncaughtException")
          return h.apply(this, arguments);
        let ee = !1;
        if (typeof J != "function") {
          if (!J.handleEvent)
            return h.apply(this, arguments);
          ee = !0;
        }
        if (Z && !Z(h, J, B, arguments))
          return;
        const xe = !!Ee && Ee.indexOf(G) !== -1, ce = g(re(arguments[2], xe)), Ue = ce == null ? void 0 : ce.signal;
        if (Ue != null && Ue.aborted)
          return;
        if (Pe) {
          for (let ge = 0; ge < Pe.length; ge++)
            if (G === Pe[ge])
              return xe ? h.call(B, G, J, ce) : h.apply(this, arguments);
        }
        const Kt = ce ? typeof ce == "boolean" ? !0 : ce.capture : !1, Wn = ce && typeof ce == "object" ? ce.once : !1, Gi = Zone.current;
        let Yt = _e[G];
        Yt || (xi(G, Y), Yt = _e[G]);
        const Kn = Yt[Kt ? we : Ne];
        let $e = B[Kn], Yn = !1;
        if ($e) {
          if (Yn = !0, q) {
            for (let ge = 0; ge < $e.length; ge++)
              if (Ae($e[ge], J))
                return;
          }
        } else
          $e = B[Kn] = [];
        let St;
        const qn = B.constructor.name, Qn = Ii[qn];
        Qn && (St = Qn[G]), St || (St = qn + v + (Y ? Y(G) : G)), x.options = ce, Wn && (x.options.once = !1), x.target = B, x.capture = Kt, x.eventName = G, x.isExisting = Yn;
        const nt = X ? L_ : void 0;
        nt && (nt.taskData = x), Ue && (x.options.signal = void 0);
        const Te = Gi.scheduleEventTask(St, J, nt, w, C);
        if (Ue) {
          x.options.signal = Ue;
          const ge = () => Te.zone.cancelTask(Te);
          h.call(Ue, "abort", ge, { once: !0 }), Te.removeAbortListener = () => Ue.removeEventListener("abort", ge);
        }
        if (x.target = null, nt && (nt.taskData = null), Wn && (x.options.once = !0), typeof Te.options != "boolean" && (Te.options = ce), Te.target = B, Te.capture = Kt, Te.eventName = G, ee && (Te.originalDelegate = J), H ? $e.unshift(Te) : $e.push(Te), P)
          return B;
      };
    };
    return A[i] = T(M, u, W, V, K), te && (A[l] = T(te, f, _, V, K, !0)), A[o] = function() {
      const h = this || e;
      let v = arguments[0];
      y && y.transferEventName && (v = y.transferEventName(v));
      const w = arguments[2], C = w ? typeof w == "boolean" ? !0 : w.capture : !1, P = arguments[1];
      if (!P)
        return N.apply(this, arguments);
      if (Z && !Z(N, P, h, arguments))
        return;
      const H = _e[v];
      let B;
      H && (B = H[C ? we : Ne]);
      const G = B && h[B];
      if (G)
        for (let J = 0; J < G.length; J++) {
          const ee = G[J];
          if (Ae(ee, P)) {
            if (G.splice(J, 1), ee.isRemoved = !0, G.length === 0 && (ee.allRemoved = !0, h[B] = null, !C && typeof v == "string")) {
              const xe = Tt + "ON_PROPERTY" + v;
              h[xe] = null;
            }
            return ee.zone.cancelTask(ee), K ? h : void 0;
          }
        }
      return N.apply(this, arguments);
    }, A[a] = function() {
      const h = this || e;
      let v = arguments[0];
      y && y.transferEventName && (v = y.transferEventName(v));
      const w = [], C = Ui(h, Y ? Y(v) : v);
      for (let P = 0; P < C.length; P++) {
        const H = C[P];
        let B = H.originalDelegate ? H.originalDelegate : H.callback;
        w.push(B);
      }
      return w;
    }, A[s] = function() {
      const h = this || e;
      let v = arguments[0];
      if (v) {
        y && y.transferEventName && (v = y.transferEventName(v));
        const w = _e[v];
        if (w) {
          const C = w[Ne], P = w[we], H = h[C], B = h[P];
          if (H) {
            const G = H.slice();
            for (let J = 0; J < G.length; J++) {
              const ee = G[J];
              let xe = ee.originalDelegate ? ee.originalDelegate : ee.callback;
              this[o].call(this, v, xe, ee.options);
            }
          }
          if (B) {
            const G = B.slice();
            for (let J = 0; J < G.length; J++) {
              const ee = G[J];
              let xe = ee.originalDelegate ? ee.originalDelegate : ee.callback;
              this[o].call(this, v, xe, ee.options);
            }
          }
        }
      } else {
        const w = Object.keys(h);
        for (let C = 0; C < w.length; C++) {
          const P = w[C], H = Di.exec(P);
          let B = H && H[1];
          B && B !== "removeListener" && this[s].call(this, B);
        }
        this[s].call(this, "removeListener");
      }
      if (K)
        return this;
    }, De(A[i], M), De(A[o], N), se && De(A[s], se), U && De(A[a], U), !0;
  }
  let b = [];
  for (let m = 0; m < n.length; m++)
    b[m] = k(n[m], r);
  return b;
}
function Ui(e, t) {
  if (!t) {
    const o = [];
    for (let a in e) {
      const s = Di.exec(a);
      let c = s && s[1];
      if (c && (!t || c === t)) {
        const u = e[a];
        if (u)
          for (let l = 0; l < u.length; l++)
            o.push(u[l]);
      }
    }
    return o;
  }
  let n = _e[t];
  n || (xi(t), n = _e[t]);
  const r = e[n[Ne]], i = e[n[we]];
  return r ? i ? r.concat(i) : r.slice() : i ? i.slice() : [];
}
function N_(e, t) {
  const n = e.Event;
  n && n.prototype && t.patchMethod(n.prototype, "stopImmediatePropagation", (r) => function(i, o) {
    i[ki] = !0, r && r.apply(i, o);
  });
}
function C_(e, t) {
  t.patchMethod(e, "queueMicrotask", (n) => function(r, i) {
    Zone.current.scheduleMicroTask("queueMicrotask", i[0]);
  });
}
const Lt = $("zoneTask");
function Ke(e, t, n, r) {
  let i = null, o = null;
  t += r, n += r;
  const a = {};
  function s(u) {
    const l = u.data;
    l.args[0] = function() {
      return u.invoke.apply(this, arguments);
    };
    const f = i.apply(e, l.args);
    return Dr(f) ? l.handleId = f : (l.handle = f, l.isRefreshable = Ir(f.refresh)), u;
  }
  function c(u) {
    const { handle: l, handleId: f } = u.data;
    return o.call(e, l ?? f);
  }
  i = Ie(e, t, (u) => function(l, f) {
    if (Ir(f[0])) {
      const E = {
        isRefreshable: !1,
        isPeriodic: r === "Interval",
        delay: r === "Timeout" || r === "Interval" ? f[1] || 0 : void 0,
        args: f
      }, S = f[0];
      f[0] = function() {
        try {
          return S.apply(this, arguments);
        } finally {
          const { handle: X, handleId: Z, isPeriodic: q, isRefreshable: K } = E;
          !q && !K && (Z ? delete a[Z] : X && (X[Lt] = null));
        }
      };
      const O = Zn(t, f[0], E, s, c);
      if (!O)
        return O;
      const { handleId: R, handle: k, isRefreshable: b, isPeriodic: m } = O.data;
      if (R)
        a[R] = O;
      else if (k && (k[Lt] = O, b && !m)) {
        const y = k.refresh;
        k.refresh = function() {
          const { zone: X, state: Z } = O;
          return Z === "notScheduled" ? (O._state = "scheduled", X._updateTaskCount(O, 1)) : Z === "running" && (O._state = "scheduling"), y.call(this);
        };
      }
      return k ?? R ?? O;
    } else
      return u.apply(e, f);
  }), o = Ie(e, n, (u) => function(l, f) {
    const E = f[0];
    let S;
    Dr(E) ? (S = a[E], delete a[E]) : (S = E == null ? void 0 : E[Lt], S ? E[Lt] = null : S = E), S != null && S.type ? S.cancelFn && S.zone.cancelTask(S) : u.apply(e, f);
  });
}
function M_(e, t) {
  const { isBrowser: n, isMix: r } = t.getGlobalObjects();
  if (!n && !r || !e.customElements || !("customElements" in e))
    return;
  const i = [
    "connectedCallback",
    "disconnectedCallback",
    "adoptedCallback",
    "attributeChangedCallback",
    "formAssociatedCallback",
    "formDisabledCallback",
    "formResetCallback",
    "formStateRestoreCallback"
  ];
  t.patchCallbacks(t, e.customElements, "customElements", "define", i);
}
function I_(e, t) {
  if (Zone[t.symbol("patchEventTarget")])
    return;
  const { eventNames: n, zoneSymbolEventNames: r, TRUE_STR: i, FALSE_STR: o, ZONE_SYMBOL_PREFIX: a } = t.getGlobalObjects();
  for (let c = 0; c < n.length; c++) {
    const u = n[c], l = u + o, f = u + i, E = a + l, S = a + f;
    r[u] = {}, r[u][o] = E, r[u][i] = S;
  }
  const s = e.EventTarget;
  if (!(!s || !s.prototype))
    return t.patchEventTarget(e, t, [s && s.prototype]), !0;
}
function D_(e, t) {
  t.patchEventPrototype(e, t);
}
function Hi(e, t, n) {
  if (!n || n.length === 0)
    return t;
  const r = n.filter((o) => o.target === e);
  if (r.length === 0)
    return t;
  const i = r[0].ignoreProperties;
  return t.filter((o) => i.indexOf(o) === -1);
}
function kr(e, t, n, r) {
  if (!e)
    return;
  const i = Hi(e, t, n);
  Mi(e, i, r);
}
function Pn(e) {
  return Object.getOwnPropertyNames(e).filter((t) => t.startsWith("on") && t.length > 2).map((t) => t.substring(2));
}
function k_(e, t) {
  if (Wt && !Ci || Zone[e.symbol("patchEvents")])
    return;
  const n = t.__Zone_ignore_on_properties;
  let r = [];
  if (zn) {
    const i = window;
    r = r.concat([
      "Document",
      "SVGElement",
      "Element",
      "HTMLElement",
      "HTMLBodyElement",
      "HTMLMediaElement",
      "HTMLFrameSetElement",
      "HTMLFrameElement",
      "HTMLIFrameElement",
      "HTMLMarqueeElement",
      "Worker"
    ]);
    const o = [];
    kr(i, Pn(i), n && n.concat(o), jn(i));
  }
  r = r.concat([
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "IDBIndex",
    "IDBRequest",
    "IDBOpenDBRequest",
    "IDBDatabase",
    "IDBTransaction",
    "IDBCursor",
    "WebSocket"
  ]);
  for (let i = 0; i < r.length; i++) {
    const o = t[r[i]];
    o != null && o.prototype && kr(o.prototype, Pn(o.prototype), n);
  }
}
function x_(e) {
  e.__load_patch("legacy", (t) => {
    const n = t[e.__symbol__("legacyPatch")];
    n && n();
  }), e.__load_patch("timers", (t) => {
    const n = "set", r = "clear";
    Ke(t, n, r, "Timeout"), Ke(t, n, r, "Interval"), Ke(t, n, r, "Immediate");
  }), e.__load_patch("requestAnimationFrame", (t) => {
    Ke(t, "request", "cancel", "AnimationFrame"), Ke(t, "mozRequest", "mozCancel", "AnimationFrame"), Ke(t, "webkitRequest", "webkitCancel", "AnimationFrame");
  }), e.__load_patch("blocking", (t, n) => {
    const r = ["alert", "prompt", "confirm"];
    for (let i = 0; i < r.length; i++) {
      const o = r[i];
      Ie(t, o, (a, s, c) => function(u, l) {
        return n.current.run(a, t, l, c);
      });
    }
  }), e.__load_patch("EventTarget", (t, n, r) => {
    D_(t, r), I_(t, r);
    const i = t.XMLHttpRequestEventTarget;
    i && i.prototype && r.patchEventTarget(t, r, [i.prototype]);
  }), e.__load_patch("MutationObserver", (t, n, r) => {
    st("MutationObserver"), st("WebKitMutationObserver");
  }), e.__load_patch("IntersectionObserver", (t, n, r) => {
    st("IntersectionObserver");
  }), e.__load_patch("FileReader", (t, n, r) => {
    st("FileReader");
  }), e.__load_patch("on_property", (t, n, r) => {
    k_(r, t);
  }), e.__load_patch("customElements", (t, n, r) => {
    M_(t, r);
  }), e.__load_patch("XHR", (t, n) => {
    u(t);
    const r = $("xhrTask"), i = $("xhrSync"), o = $("xhrListener"), a = $("xhrScheduled"), s = $("xhrURL"), c = $("xhrErrorBeforeScheduled");
    function u(l) {
      const f = l.XMLHttpRequest;
      if (!f)
        return;
      const E = f.prototype;
      function S(M) {
        return M[r];
      }
      let O = E[dn], R = E[hn];
      if (!O) {
        const M = l.XMLHttpRequestEventTarget;
        if (M) {
          const N = M.prototype;
          O = N[dn], R = N[hn];
        }
      }
      const k = "readystatechange", b = "scheduled";
      function m(M) {
        const N = M.data, U = N.target;
        U[a] = !1, U[c] = !1;
        const se = U[o];
        O || (O = U[dn], R = U[hn]), se && R.call(U, k, se);
        const te = U[o] = () => {
          if (U.readyState === U.DONE)
            if (!N.aborted && U[a] && M.state === b) {
              const z = U[n.__symbol__("loadfalse")];
              if (U.status !== 0 && z && z.length > 0) {
                const p = M.invoke;
                M.invoke = function() {
                  const d = U[n.__symbol__("loadfalse")];
                  for (let _ = 0; _ < d.length; _++)
                    d[_] === M && d.splice(_, 1);
                  !N.aborted && M.state === b && p.call(M);
                }, z.push(M);
              } else
                M.invoke();
            } else !N.aborted && U[a] === !1 && (U[c] = !0);
        };
        return O.call(U, k, te), U[r] || (U[r] = M), Y.apply(U, N.args), U[a] = !0, M;
      }
      function y() {
      }
      function X(M) {
        const N = M.data;
        return N.aborted = !0, x.apply(N.target, N.args);
      }
      const Z = Ie(E, "open", () => function(M, N) {
        return M[i] = N[2] == !1, M[s] = N[1], Z.apply(M, N);
      }), q = "XMLHttpRequest.send", K = $("fetchTaskAborting"), A = $("fetchTaskScheduling"), Y = Ie(E, "send", () => function(M, N) {
        if (n.current[A] === !0 || M[i])
          return Y.apply(M, N);
        {
          const U = {
            target: M,
            url: M[s],
            isPeriodic: !1,
            args: N,
            aborted: !1
          }, se = Zn(q, y, U, m, X);
          M && M[c] === !0 && !U.aborted && se.state === b && se.invoke();
        }
      }), x = Ie(E, "abort", () => function(M, N) {
        const U = S(M);
        if (U && typeof U.type == "string") {
          if (U.cancelFn == null || U.data && U.data.aborted)
            return;
          U.zone.cancelTask(U);
        } else if (n.current[K] === !0)
          return x.apply(M, N);
      });
    }
  }), e.__load_patch("geolocation", (t) => {
    t.navigator && t.navigator.geolocation && R_(t.navigator.geolocation, ["getCurrentPosition", "watchPosition"]);
  }), e.__load_patch("PromiseRejectionEvent", (t, n) => {
    function r(i) {
      return function(o) {
        Ui(t, i).forEach((s) => {
          const c = t.PromiseRejectionEvent;
          if (c) {
            const u = new c(i, {
              promise: o.promise,
              reason: o.rejection
            });
            s.invoke(u);
          }
        });
      };
    }
    t.PromiseRejectionEvent && (n[$("unhandledPromiseRejectionHandler")] = r("unhandledrejection"), n[$("rejectionHandledHandler")] = r("rejectionhandled"));
  }), e.__load_patch("queueMicrotask", (t, n, r) => {
    C_(t, r);
  });
}
function U_(e) {
  e.__load_patch("ZoneAwarePromise", (t, n, r) => {
    const i = Object.getOwnPropertyDescriptor, o = Object.defineProperty;
    function a(g) {
      if (g && g.toString === Object.prototype.toString) {
        const T = g.constructor && g.constructor.name;
        return (T || "") + ": " + JSON.stringify(g);
      }
      return g ? g.toString() : Object.prototype.toString.call(g);
    }
    const s = r.symbol, c = [], u = t[s("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")] !== !1, l = s("Promise"), f = s("then"), E = "__creationTrace__";
    r.onUnhandledError = (g) => {
      if (r.showUncaughtError()) {
        const T = g && g.rejection;
        T ? console.error("Unhandled Promise rejection:", T instanceof Error ? T.message : T, "; Zone:", g.zone.name, "; Task:", g.task && g.task.source, "; Value:", T, T instanceof Error ? T.stack : void 0) : console.error(g);
      }
    }, r.microtaskDrainDone = () => {
      for (; c.length; ) {
        const g = c.shift();
        try {
          g.zone.runGuarded(() => {
            throw g.throwOriginal ? g.rejection : g;
          });
        } catch (T) {
          O(T);
        }
      }
    };
    const S = s("unhandledPromiseRejectionHandler");
    function O(g) {
      r.onUnhandledError(g);
      try {
        const T = n[S];
        typeof T == "function" && T.call(this, g);
      } catch {
      }
    }
    function R(g) {
      return g && typeof g.then == "function";
    }
    function k(g) {
      return g;
    }
    function b(g) {
      return V.reject(g);
    }
    const m = s("state"), y = s("value"), X = s("finally"), Z = s("parentPromiseValue"), q = s("parentPromiseState"), K = "Promise.then", A = null, Y = !0, x = !1, M = 0;
    function N(g, T) {
      return (h) => {
        try {
          re(g, T, h);
        } catch (v) {
          re(g, !1, v);
        }
      };
    }
    const U = function() {
      let g = !1;
      return function(h) {
        return function() {
          g || (g = !0, h.apply(null, arguments));
        };
      };
    }, se = "Promise resolved with itself", te = s("currentTaskTrace");
    function re(g, T, h) {
      const v = U();
      if (g === h)
        throw new TypeError(se);
      if (g[m] === A) {
        let w = null;
        try {
          (typeof h == "object" || typeof h == "function") && (w = h && h.then);
        } catch (C) {
          return v(() => {
            re(g, !1, C);
          })(), g;
        }
        if (T !== x && h instanceof V && h.hasOwnProperty(m) && h.hasOwnProperty(y) && h[m] !== A)
          p(h), re(g, h[m], h[y]);
        else if (T !== x && typeof w == "function")
          try {
            w.call(h, v(N(g, T)), v(N(g, !1)));
          } catch (C) {
            v(() => {
              re(g, !1, C);
            })();
          }
        else {
          g[m] = T;
          const C = g[y];
          if (g[y] = h, g[X] === X && T === Y && (g[m] = g[q], g[y] = g[Z]), T === x && h instanceof Error) {
            const P = n.currentTask && n.currentTask.data && n.currentTask.data[E];
            P && o(h, te, {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: P
            });
          }
          for (let P = 0; P < C.length; )
            d(g, C[P++], C[P++], C[P++], C[P++]);
          if (C.length == 0 && T == x) {
            g[m] = M;
            let P = h;
            try {
              throw new Error("Uncaught (in promise): " + a(h) + (h && h.stack ? `
` + h.stack : ""));
            } catch (H) {
              P = H;
            }
            u && (P.throwOriginal = !0), P.rejection = h, P.promise = g, P.zone = n.current, P.task = n.currentTask, c.push(P), r.scheduleMicroTask();
          }
        }
      }
      return g;
    }
    const z = s("rejectionHandledHandler");
    function p(g) {
      if (g[m] === M) {
        try {
          const T = n[z];
          T && typeof T == "function" && T.call(this, { rejection: g[y], promise: g });
        } catch {
        }
        g[m] = x;
        for (let T = 0; T < c.length; T++)
          g === c[T].promise && c.splice(T, 1);
      }
    }
    function d(g, T, h, v, w) {
      p(g);
      const C = g[m], P = C ? typeof v == "function" ? v : k : typeof w == "function" ? w : b;
      T.scheduleMicroTask(K, () => {
        try {
          const H = g[y], B = !!h && X === h[X];
          B && (h[Z] = H, h[q] = C);
          const G = T.run(P, void 0, B && P !== b && P !== k ? [] : [H]);
          re(h, !0, G);
        } catch (H) {
          re(h, !1, H);
        }
      }, h);
    }
    const _ = "function ZoneAwarePromise() { [native code] }", L = function() {
    }, W = t.AggregateError;
    class V {
      static toString() {
        return _;
      }
      static resolve(T) {
        return T instanceof V ? T : re(new this(null), Y, T);
      }
      static reject(T) {
        return re(new this(null), x, T);
      }
      static withResolvers() {
        const T = {};
        return T.promise = new V((h, v) => {
          T.resolve = h, T.reject = v;
        }), T;
      }
      static any(T) {
        if (!T || typeof T[Symbol.iterator] != "function")
          return Promise.reject(new W([], "All promises were rejected"));
        const h = [];
        let v = 0;
        try {
          for (let P of T)
            v++, h.push(V.resolve(P));
        } catch {
          return Promise.reject(new W([], "All promises were rejected"));
        }
        if (v === 0)
          return Promise.reject(new W([], "All promises were rejected"));
        let w = !1;
        const C = [];
        return new V((P, H) => {
          for (let B = 0; B < h.length; B++)
            h[B].then((G) => {
              w || (w = !0, P(G));
            }, (G) => {
              C.push(G), v--, v === 0 && (w = !0, H(new W(C, "All promises were rejected")));
            });
        });
      }
      static race(T) {
        let h, v, w = new this((H, B) => {
          h = H, v = B;
        });
        function C(H) {
          h(H);
        }
        function P(H) {
          v(H);
        }
        for (let H of T)
          R(H) || (H = this.resolve(H)), H.then(C, P);
        return w;
      }
      static all(T) {
        return V.allWithCallback(T);
      }
      static allSettled(T) {
        return (this && this.prototype instanceof V ? this : V).allWithCallback(T, {
          thenCallback: (v) => ({ status: "fulfilled", value: v }),
          errorCallback: (v) => ({ status: "rejected", reason: v })
        });
      }
      static allWithCallback(T, h) {
        let v, w, C = new this((G, J) => {
          v = G, w = J;
        }), P = 2, H = 0;
        const B = [];
        for (let G of T) {
          R(G) || (G = this.resolve(G));
          const J = H;
          try {
            G.then((ee) => {
              B[J] = h ? h.thenCallback(ee) : ee, P--, P === 0 && v(B);
            }, (ee) => {
              h ? (B[J] = h.errorCallback(ee), P--, P === 0 && v(B)) : w(ee);
            });
          } catch (ee) {
            w(ee);
          }
          P++, H++;
        }
        return P -= 2, P === 0 && v(B), C;
      }
      constructor(T) {
        const h = this;
        if (!(h instanceof V))
          throw new Error("Must be an instanceof Promise.");
        h[m] = A, h[y] = [];
        try {
          const v = U();
          T && T(v(N(h, Y)), v(N(h, x)));
        } catch (v) {
          re(h, !1, v);
        }
      }
      get [Symbol.toStringTag]() {
        return "Promise";
      }
      get [Symbol.species]() {
        return V;
      }
      then(T, h) {
        var P;
        let v = (P = this.constructor) == null ? void 0 : P[Symbol.species];
        (!v || typeof v != "function") && (v = this.constructor || V);
        const w = new v(L), C = n.current;
        return this[m] == A ? this[y].push(C, w, T, h) : d(this, C, w, T, h), w;
      }
      catch(T) {
        return this.then(null, T);
      }
      finally(T) {
        var C;
        let h = (C = this.constructor) == null ? void 0 : C[Symbol.species];
        (!h || typeof h != "function") && (h = V);
        const v = new h(L);
        v[X] = X;
        const w = n.current;
        return this[m] == A ? this[y].push(w, v, T, T) : d(this, w, v, T, T), v;
      }
    }
    V.resolve = V.resolve, V.reject = V.reject, V.race = V.race, V.all = V.all;
    const ye = t[l] = t.Promise;
    t.Promise = V;
    const Ae = s("thenPatched");
    function Pe(g) {
      const T = g.prototype, h = i(T, "then");
      if (h && (h.writable === !1 || !h.configurable))
        return;
      const v = T.then;
      T[f] = v, g.prototype.then = function(w, C) {
        return new V((H, B) => {
          v.call(this, H, B);
        }).then(w, C);
      }, g[Ae] = !0;
    }
    r.patchThen = Pe;
    function Ee(g) {
      return function(T, h) {
        let v = g.apply(T, h);
        if (v instanceof V)
          return v;
        let w = v.constructor;
        return w[Ae] || Pe(w), v;
      };
    }
    return ye && (Pe(ye), Ie(t, "fetch", (g) => Ee(g))), Promise[n.__symbol__("uncaughtPromiseErrors")] = c, V;
  });
}
function H_(e) {
  e.__load_patch("toString", (t) => {
    const n = Function.prototype.toString, r = $("OriginalDelegate"), i = $("Promise"), o = $("Error"), a = function() {
      if (typeof this == "function") {
        const l = this[r];
        if (l)
          return typeof l == "function" ? n.call(l) : Object.prototype.toString.call(l);
        if (this === Promise) {
          const f = t[i];
          if (f)
            return n.call(f);
        }
        if (this === Error) {
          const f = t[o];
          if (f)
            return n.call(f);
        }
      }
      return n.call(this);
    };
    a[r] = n, Function.prototype.toString = a;
    const s = Object.prototype.toString, c = "[object Promise]";
    Object.prototype.toString = function() {
      return typeof Promise == "function" && this instanceof Promise ? c : s.call(this);
    };
  });
}
function B_(e, t, n, r, i) {
  const o = Zone.__symbol__(r);
  if (t[o])
    return;
  const a = t[o] = t[r];
  t[r] = function(s, c, u) {
    return c && c.prototype && i.forEach(function(l) {
      const f = `${n}.${r}::` + l, E = c.prototype;
      try {
        if (E.hasOwnProperty(l)) {
          const S = e.ObjectGetOwnPropertyDescriptor(E, l);
          S && S.value ? (S.value = e.wrapWithCurrentZone(S.value, f), e._redefineProperty(c.prototype, l, S)) : E[l] && (E[l] = e.wrapWithCurrentZone(E[l], f));
        } else E[l] && (E[l] = e.wrapWithCurrentZone(E[l], f));
      } catch {
      }
    }), a.call(t, s, c, u);
  }, e.attachOriginToPatched(t[r], a);
}
function G_(e) {
  e.__load_patch("util", (t, n, r) => {
    const i = Pn(t);
    r.patchOnProperties = Mi, r.patchMethod = Ie, r.bindArguments = $n, r.patchMacroTask = P_;
    const o = n.__symbol__("BLACK_LISTED_EVENTS"), a = n.__symbol__("UNPATCHED_EVENTS");
    t[a] && (t[o] = t[a]), t[o] && (n[o] = n[a] = t[o]), r.patchEventPrototype = N_, r.patchEventTarget = w_, r.isIEOrEdge = b_, r.ObjectDefineProperty = Gn, r.ObjectGetOwnPropertyDescriptor = Et, r.ObjectCreate = m_, r.ArraySlice = S_, r.patchClass = st, r.wrapWithCurrentZone = Xn, r.filterProperties = Hi, r.attachOriginToPatched = De, r._redefineProperty = Object.defineProperty, r.patchCallbacks = B_, r.getGlobalObjects = () => ({
      globalSources: Ii,
      zoneSymbolEventNames: _e,
      eventNames: i,
      isBrowser: zn,
      isMix: Ci,
      isNode: Wt,
      TRUE_STR: we,
      FALSE_STR: Ne,
      ZONE_SYMBOL_PREFIX: Tt,
      ADD_EVENT_LISTENER_STR: Vn,
      REMOVE_EVENT_LISTENER_STR: Fn
    });
  });
}
function j_(e) {
  U_(e), H_(e), G_(e);
}
const Bi = g_();
j_(Bi);
x_(Bi);
let xr = !1;
function F_(e = {}) {
  if (xr) {
    console.warn("[otel-lib] Monitoring has already been initialized. Skipping duplicate call.");
    return;
  }
  const {
    serviceName: t = "unknown-vue-app",
    collectorUrl: n = "http://localhost:4318/v1/traces",
    debug: r = !0,
    propagateTraceHeaderCorsUrls: i = [/.+/],
    enableDocumentLoadInstrumentation: o = !0,
    enableUserInteractionInstrumentation: a = !0,
    enableFetchInstrumentation: s = !0,
    enableXhrInstrumentation: c = !0,
    resourceAttributes: u = {}
  } = e;
  try {
    const l = new mn({
      [gr.SERVICE_NAME]: t,
      [gr.TELEMETRY_SDK_LANGUAGE]: "webjs",
      ...u
    }), f = new Js({
      resource: l
    }), E = new pc({
      url: n,
      headers: {}
    });
    f.addSpanProcessor(new fi(E)), r && f.addSpanProcessor(new Ws(new Zs())), f.register({
      contextManager: new v_()
    });
    const S = [];
    s && S.push(
      new Df({
        propagateTraceHeaderCorsUrls: i,
        applyCustomAttributesOnSpan: (O, R) => {
          console.log("[otel-lib] 🟢 Fetch intercepted request:", R);
          const k = typeof R == "string" ? R : R == null ? void 0 : R.url;
          k && (O.updateName(k), console.log(`[otel-lib] [Fetch] Updated span name to: ${k}`));
        }
      })
    ), c && S.push(
      new r_({
        propagateTraceHeaderCorsUrls: i,
        applyCustomAttributesOnSpan: (O, R) => {
          console.log("[otel-lib] 🟢 XHR intercepted xhr object:", R);
          const k = (R == null ? void 0 : R.__zone_symbol__xhrURL) || (R == null ? void 0 : R._url) || (R == null ? void 0 : R.url);
          k ? (O.updateName(k), console.log(`[otel-lib] [XHR] Updated span name to: ${k}`)) : console.warn("[otel-lib] [XHR] Could not extract URL, keys:", Object.keys(R));
        }
      })
    ), o && S.push(new c_()), a && S.push(
      new E_({
        eventNames: ["click", "submit", "keydown", "change"]
      })
    ), tf({ instrumentations: S }), xr = !0, r && (console.log(`[otel-lib] ✅ Monitoring initialized for service: "${t}"`), console.log(`[otel-lib] 📡 Collector URL: ${n}`));
  } catch (l) {
    console.error("[otel-lib] ❌ Failed to initialize monitoring:", l);
  }
}
async function X_(e, t, n = {}) {
  const i = Q.getTracer("@myorg/otel-lib").startSpan(e, { attributes: n });
  return F.with(Q.setSpan(F.active(), i), async () => {
    try {
      const o = await t();
      return i.setStatus({ code: 1 }), o;
    } catch (o) {
      throw i.setStatus({
        code: 2,
        message: o instanceof Error ? o.message : String(o)
      }), i.recordException(o), o;
    } finally {
      i.end();
    }
  });
}
function Z_() {
  const e = Q.getActiveSpan();
  return e == null ? void 0 : e.spanContext().traceId;
}
export {
  Z_ as getCurrentTraceId,
  F_ as initMonitoring,
  X_ as withSpan
};
